import { useTranslation } from "react-i18next";
import { useMemo, useState, useEffect } from "react";

const useLocale = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const getStoredCurrencySymbol = () => {
    if (typeof window === "undefined") {
      return "";
    }
    return sessionStorage.getItem("currencySymbol") || "";
  };

  const [currencyOverride, setCurrencyOverride] = useState(() =>
    getStoredCurrencySymbol()
  );

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const handleCurrencyChange = (event) => {
      if (event?.detail?.symbol) {
        setCurrencyOverride(event.detail.symbol);
      } else {
        setCurrencyOverride(getStoredCurrencySymbol());
      }
    };

    window.addEventListener("currencyChange", handleCurrencyChange);

    return () => {
      window.removeEventListener("currencyChange", handleCurrencyChange);
    };
  }, []);

  const currencyValue = currencyOverride || t("currency");

  const textData = useMemo(() => {
    return {
      All: t("All"),
      currency: currencyValue,
      details: t("details"),
      fixedDeposit: t("fixedDeposit"),
      year: t("year"),
      yearShort: t("yearShort"),
      month: t("month"),
      day: t("day"),
      calculate: t("calculate"),
      title: t("title"),
      fdCalculator: t("fdCalculator"),
      rdCalculator: t("rdCalculator"),
      sipCalculator: t("sipCalculator"),
      principalAmount: t("principalAmount"),
      interestRate: t("interestRate"),
      timePeriod: t("timePeriod"),
      years: t("years"),
      Amount: t("Amount"),
      months: t("months"),
      reset: t("reset"),
      result: t("result"),
      resultLable: t("resultLable"),
      maturityAmount: t("maturityAmount"),
      totalInterest: t("totalInterest"),
      switchLanguage: t("switchLanguage"),
      descriptionfd: t("descriptionfd"),
      totalInvestmentAmount: t("totalInvestmentAmount"),
      rateOfInterest: t("rateOfInterest"),
      days: t("days"),
      your: t("your"),
      investmentAmmount: t("investmentAmmount"),
      incrementPerYear: t("incrementPerYear"),
      compoundingFrequency: t("compoundingFrequency"),
      calculator: t("calculator"),
      footerdescription: t("footerdescription"),
      footertitle: t("footertitle"),
      History: t("History"),
      PrivacyPolicy: t("PrivacyPolicy"),
      TermsofUse: t("TermsofUse"),
      Aboutus: t("Aboutus"),
      Disclaimer: t("Disclaimer"),
      Faq: t("Faq"),
      Blog: t("Blog"),
      FinanceTitle: t("FinanceTitle"),
      mainTitle: t("mainTitle"),
      finance: t("finance"),
      tableHeadingName: t("tableHeadingName"),
      report: t("report"),
      backButton: t("backButton"),
      copyRightText: t("copyRightText", { year: currentYear }),
      storeData: t("storeData"),
      personalLoan: t("personalLoan"),
      emis: t("emis"),
      loanAmount: t("loanAmount"),
      educationLoan: t("educationLoan"),
      creditCard: t("creditCard"),
      personalLoanCalculator: t("personalLoanCalculator"),
      loanAmountRequired: t("loanAmountRequired"),
      interestRateRequired: t("interestRateRequired"),
      timrePeriodRequired: t("timrePeriodRequired"),
      loanAmountMin: t("loanAmountMin"),
      loanAmountMax: t("loanAmountMax"),
      interestRateMin: t("interestRateMin"),
      interestRateMax: t("interestRateMax"),
      timePeriodMin: t("timePeriodMin"),
      timePeriodMax: t("timePeriodMax"),

      fdInvestrequired: t("fdInvestrequired"),
      investRange: t("investRange"),
      fdTimeRequired: t("fdTimeRequired"),
      fdTimeMonth: t("fdTimeMonth"),
      fdTimeYear: t("fdTimeYear"),
      fdTimeDay: t("fdTimeDay"),
      fdInterestRequired: t("fdInterestRequired"),
      fdInterestMin: t("fdInterestMin"),
      fdInterestMax: t("fdInterestMax"),
      fdTimeMin: t("fdTimeMin"),
      fdTimeMax: t("fdTimeMax"),

      personalTital: t("personalTital"),
      retirementTitle: t("retirementTitle"),
      savingsTitle: t("savingsTitle"),
      retirementDescription: t("retirementDescription"),
      annualSalary: t("annualSalary"),
      contributionRate: t("contributionRate"),
      age: t("age"),
      retirementAge: t("retirementAge"),
      expectedReturn: t("expectedReturn"),
      currentBalance: t("currentBalance"),
      employerMatch: t("employerMatch"),
      salaryLimit: t("salaryLimit"),
      estimatedReturn: t("estimatedReturn"),
      errorMinSalary: t("errorMinSalary"),
      errorSalaryRequired: t("errorSalaryRequired"),
      errorMinContribution: t("errorMinContribution"),
      errorContributionRequired: t("errorContributionRequired"),
      errorContributionExceedsSalary: t("errorContributionExceedsSalary"),
      errorAgeRange: t("errorAgeRange"),
      errorAgeRequired: t("errorAgeRequired"),
      errorRetirementAgeRange: t("errorRetirementAgeRange"),
      errorRetirementAgeRequired: t("errorRetirementAgeRequired"),
      errorRetirementAgeGreater: t("errorRetirementAgeGreater"),
      errorReturnRate: t("errorReturnRate"),
      errorReturnRateRequired: t("errorReturnRateRequired"),
      errorCurrentBalance: t("errorCurrentBalance"),
      errorCurrentBalanceRequired: t("errorCurrentBalanceRequired"),
      errorEmployerMatch: t("errorEmployerMatch"),
      errorEmployerMatchRequired: t("errorEmployerMatchRequired"),
      errorSalaryLimit: t("errorSalaryLimit"),
      errorSalaryLimitRequired: t("errorSalaryLimitRequired"),
      limitError: t("limitError"),
      filterDropDown: {
        sipCalc: t("filterDropDown.sipCalc"),
        lumpsumCalc: t("filterDropDown.lumpsumCalc"),
        personalLoanCalc: t("filterDropDown.personalLoanCalc"),
        FDCalc: t("filterDropDown.FDCalc"),
        contributionCalc: t("filterDropDown.contributionCalc"),
        RDCalc: t("filterDropDown.RDCalc"),
        DTICalc: t("filterDropDown.DTICalc"),
        educationLoanCalc: t("filterDropDown.educationLoanCalc"),
        creditCardPayoffCalc: t("filterDropDown.creditCardPayoffCalc"),
        businessLoanCalc: t("filterDropDown.businessLoanCalc"),
        earlyLoanCalc: t("filterDropDown.earlyLoanCalc"),
        netWorthCalc: t("filterDropDown.netWorthCalc"),
        GSTCalc: t("filterDropDown.GSTCalc"),
        VatCalc: t("filterDropDown.VatCalc"),
        salaryCalc: t("filterDropDown.salaryCalc"),
        pensionCalc: t("filterDropDown.pensionCalc"),
        loanToValueCalc: t("filterDropDown.loanToValueCalc"),
        savingCalc: t("filterDropDown.savingCalc"),
        carCalc: t("filterDropDown.carCalc"),
        mortgageCalc: t("filterDropDown.mortgageCalc"),
      },
      rdCalc: {
        monthlyInvest: t("rdCalc.monthlyInvest"),
        rdRecurringDeposit: t("rdCalc.rdRecurringDeposit"),
        rdReturns: t("rdCalc.rdReturns"),
        rdDescription: t("rdCalc.rdDescription"),
        errorInvestmentRequired: t("rdCalc.errorInvestmentRequired"),
        errorInvestmentRange: t("rdCalc.errorInvestmentRange"),
        errorInterestRequired: t("rdCalc.errorInterestRequired"),
        errorInterestRange: t("rdCalc.errorInterestRange"),
        errorTimeYearsRange: t("rdCalc.errorTimeYearsRange"),
        errorTimeMonthsRange: t("rdCalc.errorTimeMonthsRange"),
        errorTimePeriodRequired: t("rdCalc.errorTimePeriodRequired"),
      },
      dtiCalc: {
        monthlyIncomeLabel: t("dtiCalc.monthlyIncomeLabel"),
        creditCardLabel: t("dtiCalc.creditCardLabel"),
        carLoanLabel: t("dtiCalc.carLoanLabel"),
        studentLoanLabel: t("dtiCalc.studentLoanLabel"),
        perMonthSuffix: t("dtiCalc.perMonthSuffix"),
        pageTitlePart1: t("dtiCalc.pageTitlePart1"),
        pageTitlePart2: t("dtiCalc.pageTitlePart2"),
        pageTitlePart3: t("dtiCalc.pageTitlePart3"),
        descriptionText: t("dtiCalc.descriptionText"),
        monthlyIncomeRequired: t("dtiCalc.monthlyIncomeRequired"),
        monthlyIncomeMin: t("dtiCalc.monthlyIncomeMin"),
        monthlyIncomeMax: t("dtiCalc.monthlyIncomeMax"),
        creditPayRequired: t("dtiCalc.creditPayRequired"),
        creditPayMin: t("dtiCalc.creditPayMin"),
        creditPayMax: t("dtiCalc.creditPayMax"),
        carPayRequired: t("dtiCalc.carPayRequired"),
        carPayMin: t("dtiCalc.carPayMin"),
        carPayMax: t("dtiCalc.carPayMax"),
        studentPayRequired: t("dtiCalc.studentPayRequired"),
        studentPayMin: t("dtiCalc.studentPayMin"),
        studentPayMax: t("dtiCalc.studentPayMax"),
      },
      educationCalc: {
        eductionTitle: t("educationCalc.eductionTitle"),
        educationdiscription: t("educationCalc.educationdiscription"),
        loanAmountRequired: t("educationCalc.loanAmountRequired"),
        loanAmountMin: t("educationCalc.loanAmountMin"),
        loanAmountMax: t("educationCalc.loanAmountMax"),
        interestRateRequired: t("educationCalc.interestRateRequired"),
        interestRateMin: t("educationCalc.interestRateMin"),
        interestRateMax: t("educationCalc.interestRateMax"),
        timePeriodRequired: t("educationCalc.timePeriodRequired"),
        timePeriodMin: t("educationCalc.timePeriodMin"),
        timePeriodMax: t("educationCalc.timePeriodMax"),
      },
      creditCalc: {
        titleMain: t("creditCalc.titleMain"),
        titleSuffix: t("creditCalc.titleSuffix"),
        description: t("creditCalc.description"),
        loanAmountLabel: t("creditCalc.loanAmountLabel"),
        loanAmountRequired: t("creditCalc.loanAmountRequired"),
        loanAmountMin: t("creditCalc.loanAmountMin"),
        loanAmountMax: t("creditCalc.loanAmountMax"),
        interestRateLabel: t("creditCalc.interestRateLabel"),
        interestRateRequired: t("creditCalc.interestRateRequired"),
        interestRateMin: t("creditCalc.interestRateMin"),
        interestRateMax: t("creditCalc.interestRateMax"),
        monthlyPayLabel: t("creditCalc.monthlyPayLabel"),
        monthlyPayRequired: t("creditCalc.monthlyPayRequired"),
        monthlyPayMin: t("creditCalc.monthlyPayMin"),
        monthlyPayMax: t("creditCalc.monthlyPayMax"),
        monthlyPayLessThanLoanAmount: t(
          "creditCalc.monthlyPayLessThanLoanAmount",
        ),
        errorMessage: t("creditCalc.errorMessage"),
        paymentLimit: t("creditCalc.paymentLimit"),
      },
      bussinesCal: {
        titleMain: t("bussinesCal.titleMain"),
        description: t("bussinesCal.description"),
        loanAmountRequired: t("bussinesCal.loanAmountRequired"),
        loanAmountMin: t("bussinesCal.loanAmountMin"),
        loanAmountMax: t("bussinesCal.loanAmountMax"),
        interestRateRequired: t("bussinesCal.interestRateRequired"),
        interestRateMin: t("bussinesCal.interestRateMin"),
        interestRateMax: t("bussinesCal.interestRateMax"),
        timePeriodRequired: t("bussinesCal.timePeriodRequired"),
        timePeriodMin: t("bussinesCal.timePeriodMin"),
        timePeriodMax: t("bussinesCal.timePeriodMax"),
      },
      earlyPayoffCalc: {
        titleMain: t("earlyPayoffCalc.titleMain"),
        titleSuffix: t("earlyPayoffCalc.titleSuffix"),
        description: t("earlyPayoffCalc.description"),
        outstandingAmountLabel: t("earlyPayoffCalc.outstandingAmountLabel"),
        prepaymentAmountLabel: t("earlyPayoffCalc.prepaymentAmountLabel"),
        loanAmountRequired: t("earlyPayoffCalc.loanAmountRequired"),
        loanAmountMin: t("earlyPayoffCalc.loanAmountMin"),
        loanAmountMax: t("earlyPayoffCalc.loanAmountMax"),
        interestRateRequired: t("earlyPayoffCalc.interestRateRequired"),
        interestRateMin: t("earlyPayoffCalc.interestRateMin"),
        interestRateMax: t("earlyPayoffCalc.interestRateMax"),
        timePeriodRequired: t("earlyPayoffCalc.timePeriodRequired"),
        timePeriodMinYear: t("earlyPayoffCalc.timePeriodMinYear"),
        timePeriodMinMonth: t("earlyPayoffCalc.timePeriodMinMonth"),
        prepaymentRequired: t("earlyPayoffCalc.prepaymentRequired"),
        timePeriodMaxYear: t("earlyPayoffCalc.timePeriodMaxYear"),
        timePeriodMaxMonth: t("earlyPayoffCalc.timePeriodMaxMonth"),
        prepaymentRequired: t("earlyPayoffCalc.prepaymentRequired"),
        prepaymentMin: t("earlyPayoffCalc.prepaymentMin"),
        prepaymentMax: t("earlyPayoffCalc.prepaymentMax"),
        prepaymentLessThanLoanAmount: t(
          "earlyPayoffCalc.prepaymentLessThanLoanAmount",
        ),
        timecondition: t("earlyPayoffCalc.timecondition"),
      },
      netWorthCalc: {
        title: t("netWorthCalc.title"),
        description: t("netWorthCalc.description"),
        assetsTitle: t("netWorthCalc.assetsTitle"),
        liabilitiesTitle: t("netWorthCalc.liabilitiesTitle"),
        sharesEquityLabel: t("netWorthCalc.sharesEquityLabel"),
        incomeAssetsLabel: t("netWorthCalc.incomeAssetsLabel"),
        cashAccountsLabel: t("netWorthCalc.cashAccountsLabel"),
        estateValueLabel: t("netWorthCalc.estateValueLabel"),
        goldJewelryLabel: t("netWorthCalc.goldJewelryLabel"),
        otherAssetsLabel: t("netWorthCalc.otherAssetsLabel"),
        homeLoansLabel: t("netWorthCalc.homeLoansLabel"),
        otherLoansLabel: t("netWorthCalc.otherLoansLabel"),
        incomeTaxLonasLabel: t("netWorthCalc.incomeTaxLonasLabel"),
        billsPaymentsLabel: t("netWorthCalc.billsPaymentsLabel"),
        creditCardDuesLabel: t("netWorthCalc.creditCardDuesLabel"),
        otherLiabilitiesLabel: t("netWorthCalc.otherLiabilitiesLabel"),
        sharesEquityRequired: t("netWorthCalc.sharesEquityRequired"),
        sharesEquityMin: t("netWorthCalc.sharesEquityMin"),
        sharesEquityMax: t("netWorthCalc.sharesEquityMax"),
        incomeAssetsRequired: t("netWorthCalc.incomeAssetsRequired"),
        incomeAssetsMin: t("netWorthCalc.incomeAssetsMin"),
        incomeAssetsMax: t("netWorthCalc.incomeAssetsMax"),
        cashAccountsRequired: t("netWorthCalc.cashAccountsRequired"),
        cashAccountsMin: t("netWorthCalc.cashAccountsMin"),
        cashAccountsMax: t("netWorthCalc.cashAccountsMax"),
        estateValueRequired: t("netWorthCalc.estateValueRequired"),
        estateValueMin: t("netWorthCalc.estateValueMin"),
        estateValueMax: t("netWorthCalc.estateValueMax"),
        goldJewelryRequired: t("netWorthCalc.goldJewelryRequired"),
        goldJewelryMin: t("netWorthCalc.goldJewelryMin"),
        goldJewelryMax: t("netWorthCalc.goldJewelryMax"),
        otherAssetsRequired: t("netWorthCalc.otherAssetsRequired"),
        otherAssetsMin: t("netWorthCalc.otherAssetsMin"),
        otherAssetsMax: t("netWorthCalc.otherAssetsMax"),
        homeLoansRequired: t("netWorthCalc.homeLoansRequired"),
        homeLoansMin: t("netWorthCalc.homeLoansMin"),
        homeLoansMax: t("netWorthCalc.homeLoansMax"),
        otherLoansRequired: t("netWorthCalc.otherLoansRequired"),
        otherLoansMin: t("netWorthCalc.otherLoansMin"),
        otherLoansMax: t("netWorthCalc.otherLoansMax"),
        incomeTaxLonasRequired: t("netWorthCalc.incomeTaxLonasRequired"),
        incomeTaxLonasMin: t("netWorthCalc.incomeTaxLonasMin"),
        incomeTaxLonasMax: t("netWorthCalc.incomeTaxLonasMax"),
        billsPaymentsRequired: t("netWorthCalc.billsPaymentsRequired"),
        billsPaymentsMin: t("netWorthCalc.billsPaymentsMin"),
        billsPaymentsMax: t("netWorthCalc.billsPaymentsMax"),
        creditCardDuesRequired: t("netWorthCalc.creditCardDuesRequired"),
        creditCardDuesMin: t("netWorthCalc.creditCardDuesMin"),
        creditCardDuesMax: t("netWorthCalc.creditCardDuesMax"),
        otherLiabilitiesRequired: t("netWorthCalc.otherLiabilitiesRequired"),
        otherLiabilitiesMin: t("netWorthCalc.otherLiabilitiesMin"),
        otherLiabilitiesMax: t("netWorthCalc.otherLiabilitiesMax"),
      },
      annualSalaryCalc: {
        title: t("annualSalaryCalc.title"),
        salary: t("annualSalaryCalc.salary"),
        description: t("annualSalaryCalc.description"),
        hourlyWageLabel: t("annualSalaryCalc.hourlyWageLabel"),
        hoursPerWeekLabel: t("annualSalaryCalc.hoursPerWeekLabel"),
        offDaysPerWeekLabel: t("annualSalaryCalc.offDaysPerWeekLabel"),
        hourlyWageRequired: t("annualSalaryCalc.hourlyWageRequired"),
        hourlyWageMin: t("annualSalaryCalc.hourlyWageMin"),
        hourlyWageMax: t("annualSalaryCalc.hourlyWageMax"),
        hoursPerWeekRequired: t("annualSalaryCalc.hoursPerWeekRequired"),
        hoursPerWeekMin: t("annualSalaryCalc.hoursPerWeekMin"),
        hoursPerWeekMax: t("annualSalaryCalc.hoursPerWeekMax"),
        offDaysPerWeekRequired: t("annualSalaryCalc.offDaysPerWeekRequired"),
        offDaysPerWeekMin: t("annualSalaryCalc.offDaysPerWeekMin"),
        offDaysPerWeekMax: t("annualSalaryCalc.offDaysPerWeekMax"),
      },
      vatCalc: {
        vatCalc: t("vatCalc.vatCalc"),
        gst: t("vatCalc.gst"),
        vat: t("vatCalc.vat"),
        taxslab: t("vatCalc.taxslab"),
        title: t("vatCalc.title"),
        description: t("vatCalc.description"),
        totalAmountLabel: t("vatCalc.totalAmountLabel"),
        vatLabel: t("vatCalc.vatLabel"),
        excludingVatLabel: t("vatCalc.excludingVatLabel"),
        includingVatLabel: t("vatCalc.includingVatLabel"),
        totalAmountRequired: t("vatCalc.totalAmountRequired"),
        totalAmountMin: t("vatCalc.totalAmountMin"),
        totalAmountMax: t("vatCalc.totalAmountMax"),
        vatRequired: t("vatCalc.vatRequired"),
        vatMin: t("vatCalc.vatMin"),
        vatMax: t("vatCalc.vatMax"),
      },
      gstCalc: {
        taxslab: t("gstCalc.taxslab"),
        totalAmountLabel: t("gstCalc.totalAmountLabel"),
        gstLabel: t("gstCalc.gstLabel"),
        excludingGstLabel: t("gstCalc.excludingGstLabel"),
        includingGstLabel: t("gstCalc.includingGstLabel"),
        totalAmountRequired: t("gstCalc.totalAmountRequired"),
        totalAmountMin: t("gstCalc.totalAmountMin"),
        totalAmountMax: t("gstCalc.totalAmountMax"),
        gstRequired: t("gstCalc.gstRequired"),
        gstMin: t("gstCalc.gstMin"),
        gstMax: t("gstCalc.gstMax"),
      },
      pensionCalc: {
        Amount: t("pensionCalc.Amount"),
        title: t("pensionCalc.title"),
        description: t("pensionCalc.description"),
        currentAgeLabel: t("pensionCalc.currentAgeLabel"),
        investUpToAgeLabel: t("pensionCalc.investUpToAgeLabel"),
        totalContributionYearsLabel: t(
          "pensionCalc.totalContributionYearsLabel",
        ),
        contributionAmountLabel: t("pensionCalc.contributionAmountLabel"),
        annualIncreaseLabel: t("pensionCalc.annualIncreaseLabel"),
        expectedReturnLabel: t("pensionCalc.expectedReturnLabel"),
        investInAnnuityLabel: t("pensionCalc.investInAnnuityLabel"),
        annuityRateLabel: t("pensionCalc.annuityRateLabel"),
        currentAgeRequired: t("pensionCalc.currentAgeRequired"),
        currentAgeMin: t("pensionCalc.currentAgeMin"),
        currentAgeMax: t("pensionCalc.currentAgeMax"),
        investUpToAgeRequired: t("pensionCalc.investUpToAgeRequired"),
        investUpToAgeMin: t("pensionCalc.investUpToAgeMin"),
        investUpToAgeMax: t("pensionCalc.investUpToAgeMax"),
        investUpToAgeTest: t("pensionCalc.investUpToAgeTest"),
        totalContributionYearsRequired: t(
          "pensionCalc.totalContributionYearsRequired",
        ),
        totalContributionYearsMin: t("pensionCalc.totalContributionYearsMin"),
        totalContributionYearsMax: t("pensionCalc.totalContributionYearsMax"),
        contributionAmountRequired: t("pensionCalc.contributionAmountRequired"),
        contributionAmountMin: t("pensionCalc.contributionAmountMin"),
        contributionAmountMax: t("pensionCalc.contributionAmountMax"),
        annualIncreaseRequired: t("pensionCalc.annualIncreaseRequired"),
        annualIncreaseMin: t("pensionCalc.annualIncreaseMin"),
        annualIncreaseMax: t("pensionCalc.annualIncreaseMax"),
        expectedReturnRequired: t("pensionCalc.expectedReturnRequired"),
        expectedReturnMin: t("pensionCalc.expectedReturnMin"),
        expectedReturnMax: t("pensionCalc.expectedReturnMax"),
        investInAnnuityRequired: t("pensionCalc.investInAnnuityRequired"),
        investInAnnuityMin: t("pensionCalc.investInAnnuityMin"),
        investInAnnuityMax: t("pensionCalc.investInAnnuityMax"),
        annuityRateRequired: t("pensionCalc.annuityRateRequired"),
        annuityRateMin: t("pensionCalc.annuityRateMin"),
        annuityRateMax: t("pensionCalc.annuityRateMax"),
      },
      ltvCalc: {
        title: t("ltvCalc.title"),
        ratio: t("ltvCalc.ratio"),
        description: t("ltvCalc.description"),
        propertyValueLabel: t("ltvCalc.propertyValueLabel"),
        interestRateLabel: t("ltvCalc.interestRateLabel"),
        timePeriodLabel: t("ltvCalc.timePeriodLabel"),
        salariedLabel: t("ltvCalc.salariedLabel"),
        selfEmployedLabel: t("ltvCalc.selfEmployedLabel"),
        residentialLabel: t("ltvCalc.residentialLabel"),
        commercialLabel: t("ltvCalc.commercialLabel"),
        calculateButton: t("ltvCalc.calculateButton"),
        resetButton: t("ltvCalc.resetButton"),
        resultTitle: t("ltvCalc.resultTitle"),
        propertyRequired: t("ltvCalc.propertyRequired"),
        propertyValue: t("ltvCalc.propertyValue"),
        intrestRequired: t("ltvCalc.intrestRequired"),
        interestRate: t("ltvCalc.interestRate"),
        timePeriod: t("ltvCalc.timePeriod"),
        timeRequired: t("ltvCalc.timeRequired"),
      },
      savingCalc: {
        Amount: t("savingCalc.Amount"),
        title: t("savingCalc.title"),
        description: t("savingCalc.description"),
        savingGoalAmountLabel: t("savingCalc.savingGoalAmountLabel"),
        existingInvestmentLabel: t("savingCalc.existingInvestmentLabel"),
        expectedInflationLabel: t("savingCalc.expectedInflationLabel"),
        expectedReturnLabel: t("savingCalc.expectedReturnLabel"),
        timePeriodLabel: t("savingCalc.timePeriodLabel"),
        calculateButton: t("savingCalc.calculateButton"),
        resetButton: t("savingCalc.resetButton"),
        resultTitle: t("savingCalc.resultTitle"),
        savingGoalAmount: t("savingCalc.savingGoalAmount"),
        existingInvestment: t("savingCalc.existingInvestment"),
        expectedInflation: t("savingCalc.expectedInflation"),
        expectedReturn: t("savingCalc.expectedReturn"),
        timePeriod: t("savingCalc.timePeriod"),
        savingrequired: t("savingCalc.savingrequired"),
        existingInvestmentRequired: t("savingCalc.existingInvestmentRequired"),
        expectedInflationRequired: t("savingCalc.expectedInflationRequired"),
        expectedReturnRequired: t("savingCalc.expectedReturnRequired"),
        timePeriodRequired: t("savingCalc.timePeriodRequired"),
        exceedError: t("savingCalc.exceedError"),
      },
      carCalc: {
        title: t("carCalc.title"),
        Costs: t("carCalc.Costs"),
        perMonthSuffix: t("carCalc.perMonthSuffix"),
        description: t("carCalc.description"),
        downPaymentLabel: t("carCalc.downPaymentLabel"),
        monthsLabel: t("carCalc.monthsLabel"),
        monthlyPaymentLabel: t("carCalc.monthlyPaymentLabel"),
        securityDepositLabel: t("carCalc.securityDepositLabel"),
        purchasePriceLabel: t("carCalc.purchasePriceLabel"),
        interestRateLabel: t("carCalc.interestRateLabel"),
        commonAssumptions: t("carCalc.commonAssumptions"),
        leaseInformation: t("carCalc.leaseInformation"),
        purchaseInformation: t("carCalc.purchaseInformation"),

        downPayment: t("carCalc.downPayment"),
        months: t("carCalc.months"),
        monthlyPayment: t("carCalc.monthlyPayment"),
        securityDeposit: t("carCalc.securityDeposit"),
        purchasePrice: t("carCalc.purchasePrice"),
        interestRate: t("carCalc.interestRate"),
        downPaymentRequired: t("carCalc.downPaymentRequired"),
        monthsRequired: t("carCalc.monthsRequired"),
        monthlyPaymentRequired: t("carCalc.monthlyPaymentRequired"),
        securityDepositRequired: t("carCalc.securityDepositRequired"),
        purchasePriceRequired: t("carCalc.purchasePriceRequired"),
        interestRateRequired: t("carCalc.interestRateRequired"),
        valueLimitError: t("carCalc.valueLimitError"),
      },
      mortgageCalc: {
        title: t("mortgageCalc.title"),
        description: t("mortgageCalc.description"),
        dueDate: t("mortgageCalc.dueDate"),
        mortgageRefinance: t("mortgageCalc.mortgageRefinance"),
        currentMortgage: t("mortgageCalc.currentMortgage"),
        originalMortgageAmountLabel: t(
          "mortgageCalc.originalMortgageAmountLabel",
        ),
        dueDateLabel: t("mortgageCalc.dueDateLabel"),
        interestRateLabel: t("mortgageCalc.interestRateLabel"),
        mortgageTermLabel: t("mortgageCalc.mortgageTermLabel"),
        newMortgage: t("mortgageCalc.newMortgage"),
        newDueDateLabel: t("mortgageCalc.newDueDateLabel"),
        newInterestRateLabel: t("mortgageCalc.newInterestRateLabel"),
        newLoanTermLabel: t("mortgageCalc.newLoanTermLabel"),
        refinancingCostsLabel: t("mortgageCalc.refinancingCostsLabel"),
        mortgagePointsLabel: t("mortgageCalc.mortgagePointsLabel"),
        cashInOutLabel: t("mortgageCalc.cashInOutLabel"),

        mortgageAmount: t("mortgageCalc.mortgageAmount"),
        interestRate: t("mortgageCalc.interestRate"),
        loanTerm: t("mortgageCalc.loanTerm"),
        newLoanTerm: t("mortgageCalc.newLoanTerm"),
        newInterestRate: t("mortgageCalc.newInterestRate"),
        mortgagePoints: t("mortgageCalc.mortgagePoints"),
        refinancingCost: t("mortgageCalc.refinancingCost"),
        cashOut: t("mortgageCalc.cashOut"),
        mortgageAmountRequired: t("mortgageCalc.mortgageAmountRequired"),
        interestRateRequired: t("mortgageCalc.interestRateRequired"),
        loanTermRequired: t("mortgageCalc.loanTermRequired"),
        newLoanTermRequired: t("mortgageCalc.newLoanTermRequired"),
        newInterestRateRequired: t("mortgageCalc.newInterestRateRequired"),
        mortgagePointsRequired: t("mortgageCalc.mortgagePointsRequired"),
        refinancingCostRequired: t("mortgageCalc.refinancingCostRequired"),
        cashOutRequired: t("mortgageCalc.cashOutRequired"),
        years: t("mortgageCalc.years"),
        months: t("mortgageCalc.months"),
        intrestRateYearsMin: t("mortgageCalc.intrestRateYearsMin"),
        intrestRateMonthsMin: t("mortgageCalc.intrestRateMonthsMin"),
        intrestRateDaysMin: t("mortgageCalc.intrestRateDaysMin"),

        intrestRateYearsMax: t("mortgageCalc.intrestRateYearsMax"),
        intrestRateMonthsMax: t("mortgageCalc.intrestRateMonthsMax"),
        intrestRateDaysMax: t("mortgageCalc.intrestRateDaysMax"),

        newLoanTermYearsMin: t("mortgageCalc.newLoanTermYearsMin"),
        newLoanTermMonthsMin: t("mortgageCalc.newLoanTermMonthsMin"),
        newLoanTermDaysMin: t("mortgageCalc.newLoanTermDaysMin"),

        newLoanTermYearsMax: t("mortgageCalc.newLoanTermYearsMax"),
        newLoanTermMonthsMax: t("mortgageCalc.newLoanTermMonthsMax"),
        newLoanTermDaysMax: t("mortgageCalc.newLoanTermDaysMax"),

        chartTitle: t("mortgageCalc.chartTitle"),
        dueDateRequired: t("mortgageCalc.dueDateRequired"),
        newDueDateRequired: t("mortgageCalc.newDueDateRequired"),
        invalidDate: t("mortgageCalc.invalidDate"),
        newDueDateMustBeAfterOrEqualToDueDate: t(
          "mortgageCalc.newDueDateMustBeAfterOrEqualToDueDate",
        ),
      },
      sipCalc: {
        sip: t("sipCalc.sip"),
        Lumpsum: t("sipCalc.Lumpsum"),
        calculate: t("sipCalc.calculate"),
        invest: t("sipCalc.invest"),
        return: t("sipCalc.return"),
        description: t("sipCalc.description"),
        age: t("sipCalc.age"),
        info: t("sipCalc.info"),
        monthlyInvestment: t("sipCalc.monthlyInvestment"),
        incrementPerYear: t("sipCalc.incrementPerYear"),
        approxReturn: t("sipCalc.approxReturn"),
        noOfInvestementYear: t("sipCalc.noOfInvestementYear"),
        swpStartYear: t("sipCalc.swpStartYear"),
        yearlyWithdraw: t("sipCalc.yearlyWithdraw"),
        yearlyIncrementInWithdrawSwp: t("sipCalc.yearlyIncrementInWithdrawSwp"),
        addLumpsum: t("sipCalc.addLumpsum"),
        addSWP: t("sipCalc.addSWP"),
        addFreeAmount: t("sipCalc.addFreeAmount"),
        edit: t("sipCalc.edit"),
        add: t("sipCalc.add"),
        ageerror: t("sipCalc.ageerror"),
        errormonthlyInvestment: t("sipCalc.errormonthlyInvestment"),
        errorincrementPerYear: t("sipCalc.errorincrementPerYear"),
        errorapproxReturn: t("sipCalc.errorapproxReturn"),
        errornoOfInvestementYear: t("sipCalc.errornoOfInvestementYear"),
        errorswpStartYear: t("sipCalc.errorswpStartYear"),
        erroryearlyWithdraw: t("sipCalc.erroryearlyWithdraw"),
        erroryearlyIncrementInWithdrawSwp: t(
          "sipCalc.erroryearlyIncrementInWithdrawSwp",
        ),
      },
      lumpsumCalc: {
        age: t("lumpsumCalc.age"),
        info: t("lumpsumCalc.info"),
        totalInvestment: t("lumpsumCalc.totalInvestment"),
        approxReturn: t("lumpsumCalc.approxReturn"),
        swpStartYear: t("lumpsumCalc.swpStartYear"),
        yearlyWithdraw: t("lumpsumCalc.yearlyWithdraw"),
        yearlyIncrementInWithdrawSwp: t(
          "lumpsumCalc.yearlyIncrementInWithdrawSwp",
        ),
        ageError: t("lumpsumCalc.ageError"),
        ageRequired: t("lumpsumCalc.ageRequired"),
        ageMin: t("lumpsumCalc.ageMin"),
        ageMax: t("lumpsumCalc.ageMax"),
        totalInvestmentRequired: t("lumpsumCalc.totalInvestmentRequired"),
        totalInvestmentError: t("lumpsumCalc.totalInvestmentError"),
        totalInvestmentMin: t("lumpsumCalc.totalInvestmentMin"),
        totalInvestmentMax: t("lumpsumCalc.totalInvestmentMax"),
        approxReturnRequired: t("lumpsumCalc.approxReturnRequired"),
        approxReturnError: t("lumpsumCalc.approxReturnError"),
        approxReturnMin: t("lumpsumCalc.approxReturnMin"),
        approxReturnMax: t("lumpsumCalc.approxReturnMax"),
        swpStartYearError: t("lumpsumCalc.swpStartYearError"),
        swpStartYearMin: t("lumpsumCalc.swpStartYearMin"),
        swpStartYearMax: t("lumpsumCalc.swpStartYearMax"),
        yearlyWithdrawError: t("lumpsumCalc.yearlyWithdrawError"),
        yearlyWithdrawMin: t("lumpsumCalc.yearlyWithdrawMin"),
        yearlyWithdrawMax: t("lumpsumCalc.yearlyWithdrawMax"),
        yearlyIncrementInWithdrawSwpError: t(
          "lumpsumCalc.yearlyIncrementInWithdrawSwpError",
        ),
        yearlyIncrementInWithdrawSwpMin: t(
          "lumpsumCalc.yearlyIncrementInWithdrawSwpMin",
        ),
        yearlyIncrementInWithdrawSwpMax: t(
          "lumpsumCalc.yearlyIncrementInWithdrawSwpMax",
        ),
      },
      chartLabels: {
        emis: t("chartLabels.emis"),
        principle: t("chartLabels.principle"),
        intrestAmount: t("chartLabels.intrestAmount"),
        totalAmount: t("chartLabels.totalAmount"),
        totalValue: t("chartLabels.totalValue"),
        estimateReturn: t("chartLabels.estimateReturn"),
        totalInvestment: t("chartLabels.totalInvestment"),
        monthlyRetiremnet: t("chartLabels.monthlyRetiremnet"),
        withEmploye: t("chartLabels.withEmploye"),
        withoutEmploye: t("chartLabels.withoutEmploye"),
        debtRatio: t("chartLabels.debtRatio"),
        monthlyDebt: t("chartLabels.monthlyDebt"),
        remainingIncome: t("chartLabels.remainingIncome"),
        monthlyEmi: t("chartLabels.monthlyEmi"),
        noOfmonth: t("chartLabels.noOfmonth"),
        loanAmount: t("chartLabels.loanAmount"),
        intrest: t("chartLabels.intrest"),
        totalPayment: t("chartLabels.totalPayment"),
        newEMi: t("chartLabels.newEMi"),
        remainingPrinciple: t("chartLabels.remainingPrinciple"),
        yourNetworth: t("chartLabels.yourNetworth"),
        totalAssets: t("chartLabels.totalAssets"),
        totalLiabilities: t("chartLabels.totalLiabilities"),
        totalGst: t("chartLabels.totalGst"),
        gstAMoount: t("chartLabels.gstAMoount"),
        anualSalary: t("chartLabels.anualSalary"),
        totalHour: t("chartLabels.totalHour"),
        monthlyPension: t("chartLabels.monthlyPension"),
        totalCorpus: t("chartLabels.totalCorpus"),
        intrestEarned: t("chartLabels.intrestEarned"),
        totalTaxSaving: t("chartLabels.totalTaxSaving"),
        annuityValue: t("chartLabels.annuityValue"),
        withDrawAmount: t("chartLabels.withDrawAmount"),
        monthlyInvestment: t("chartLabels.monthlyInvestment"),
        futureValue: t("chartLabels.futureValue"),
        existingInvestment: t("chartLabels.existingInvestment"),
        carBusyCost: t("chartLabels.carBusyCost"),
        carLeast: t("chartLabels.carLeast"),
        carBuyTotal: t("chartLabels.carBuyTotal"),
        purchasePrice: t("chartLabels.purchasePrice"),
        carLeaseTotal: t("chartLabels.carLeaseTotal"),
        securityDeposite: t("chartLabels.securityDeposite"),
        downPayment: t("chartLabels.downPayment"),
        remainingBalance: t("chartLabels.remainingBalance"),
        newLoanpay: t("chartLabels.newLoanpay"),
        monthlyPay: t("chartLabels.monthlyPay"),
        newMonthlyPay: t("chartLabels.newMonthlyPay"),
        monthlySaving: t("chartLabels.monthlySaving"),
        refinanceCost: t("chartLabels.refinanceCost"),
        breackEven: t("chartLabels.breackEven"),
        elapsed: t("chartLabels.elapsed"),
        mortgagePoint: t("chartLabels.mortgagePoint"),
        cashInOut: t("chartLabels.cashInOut"),
        totalIntrest: t("chartLabels.totalIntrest"),
        vatAmount: t("chartLabels.vatAmount"),
        totalVat: t("chartLabels.totalVat"),
        newMonthlyamt: t("chartLabels.newMonthlyamt"),
        totalWithrawal: t("chartLabels.totalWithrawal"),
        estReturn: t("chartLabels.estReturn"),
        currentLoan: t("chartLabels.currentLoan"),
        currentIntrest: t("chartLabels.currentIntrest"),
        refinanceLoan: t("chartLabels.refinanceLoan"),
        refinanceIntrest: t("chartLabels.refinanceIntrest"),
        savingAmount: t("chartLabels.savingAmount"),
      },
      personalError: {
        loanAmountRequired: t("personalError.loanAmountRequired"),
        loanAmountMin: t("personalError.loanAmountMin"),
        loanAmountMax: t("personalError.loanAmountMax"),
        timePeriodRequired: t("personalError.timePeriodRequired"),
        timePeriodMin: t("personalError.timePeriodMin"),
        timePeriodMax: t("personalError.timePeriodMax"),
        interestRateRequired: t("personalError.interestRateRequired"),
        interestRateMin: t("personalError.interestRateMin"),
        interestRateMax: t("personalError.interestRateMax"),
      },

      fdError: {
        investmentRequired: t("fdError.investmentRequired"),
        investmentMin: t("fdError.investmentMin"),
        investmentMax: t("fdError.investmentMax"),
        timeRequired: t("fdError.timeRequired"),
        timeMinYear: t("fdError.timeMinYear"),
        timeMaxYear: t("fdError.timeMaxYear"),
        timeMinMonth: t("fdError.timeMinMonth"),
        timeMaxMonth: t("fdError.timeMaxMonth"),
        timeMinDay: t("fdError.timeMinDay"),
        timeMaxDay: t("fdError.timeMaxDay"),
        interestRequired: t("fdError.interestRequired"),
        interestMin: t("fdError.interestMin"),
        interestMax: t("fdError.interestMax"),
      },
      tableLabels: {
        month: t("tableLabels.month"),
        year: t("tableLabels.year"),
        day: t("tableLabels.day"),
        openingBalance: t("tableLabels.openingBalance"),
        intrestPaid: t("tableLabels.intrestPaid"),
        principlePaid: t("tableLabels.principlePaid"),
        monthlyPayment: t("tableLabels.monthlyPayment"),
        totalrepayment: t("tableLabels.totalrepayment"),
        totalInterestPaid: t("tableLabels.totalInterestPaid"),
        age: t("tableLabels.age"),
        salary: t("tableLabels.salary"),
        contribution: t("tableLabels.contribution"),
        employerMatch: t("tableLabels.employerMatch"),
        cumulativeamount: t("tableLabels.cumulativeamount"),
        totalContribution: t("tableLabels.totalContribution"),
        payment: t("tableLabels.payment"),
        remainingBalance: t("tableLabels.remainingBalance"),
        monthlyEmi: t("tableLabels.monthlyEmi"),
        totalPay: t("tableLabels.totalPay"),
        principle: t("tableLabels.principle"),
        intrest: t("tableLabels.intrest"),
        cumulativeintrest: t("tableLabels.cumulativeintrest"),
        principleRepaid: t("tableLabels.principleRepaid"),
        remainingLoan: t("tableLabels.remainingLoan"),
        initialInvestment: t("tableLabels.initialInvestment"),
        additionalInvestment: t("tableLabels.additionalInvestment"),
        totalInvestment: t("tableLabels.totalInvestment"),
        yearlyReturn: t("tableLabels.yearlyReturn"),
        swpAmount: t("tableLabels.swpAmount"),
        yearlyReturnAfterSWP: t("tableLabels.yearlyReturnAfterSWP"),
        monthlyReturn: t("tableLabels.monthlyReturn"),
        ltcgAmount: t("tableLabels.ltcgAmount"),
        monthlydeposite: t("tableLabels.monthlydeposite"),
        totalamount: t("tableLabels.totalamount"),
        totalintrestearnd: t("tableLabels.totalintrestearnd"),
        cumulativeSavings: t("tableLabels.cumulativeSavings"),
        goalInflaction: t("tableLabels.goalInflaction"),
        remainingAmount: t("tableLabels.remainingAmount"),
        monthlyInvestment: t("tableLabels.monthlyInvestment"),
        investmentAmounts: t("tableLabels.investmentAmounts"),
        returnAfterSWP: t("tableLabels.returnAfterSWP"),
        monthReturn: t("tableLabels.monthReturn"),
      },

      privacyPolicy: {
        header: t("privacyPolicy.header"),
        intro: t("privacyPolicy.intro"),
        informationWeCollect: t("privacyPolicy.informationWeCollect"),
        analyticsInfoTitle: t("privacyPolicy.analyticsInfoTitle"),
        analyticsInfoDesc: t("privacyPolicy.analyticsInfoDesc"),

        useOfInformation: t("privacyPolicy.useOfInformation"),
        useOfInformationDesc: t("privacyPolicy.useOfInformationDesc"),
        useOfInformationList: [
          t("privacyPolicy.useOfInformationList.1"),
          t("privacyPolicy.useOfInformationList.2"),
        ],
        disclosureOfInformation: t("privacyPolicy.disclosureOfInformation"),
        disclosureOfInformationDesc: t(
          "privacyPolicy.disclosureOfInformationDesc",
        ),
        // informationSharing: t("privacyPolicy.informationSharing"),
        disclosureItems: [
          {
            title: t("privacyPolicy.disclosureItems.1.title"),
            desc: t("privacyPolicy.disclosureItems.1.desc"),
          },
          {
            title: t("privacyPolicy.disclosureItems.2.title"),
            desc: t("privacyPolicy.disclosureItems.2.desc"),
          },
          {
            title: t("privacyPolicy.disclosureItems.3.title"),
            desc: t("privacyPolicy.disclosureItems.3.desc"),
          },
        ],

        cookiesTitle: t("privacyPolicy.cookiesTitle"),
        cookiesDesc: t("privacyPolicy.cookiesDesc"),

        securityTitle: t("privacyPolicy.securityTitle"),
        securityDesc: t("privacyPolicy.securityDesc"),

        childrenPolicyTitle: t("privacyPolicy.childrenPolicyTitle"),
        childrenPolicyDesc: t("privacyPolicy.childrenPolicyDesc"),

        contactTitle: t("privacyPolicy.contactTitle"),
        contactDesc: t("privacyPolicy.contactDesc"),
      },
      termsOfUse: {
        title: t("termsOfUse.title"),
        intro1: t("termsOfUse.intro1"),
        href: t("termsOfUse.href"),
        introLink: t("termsOfUse.introLink"),
        intro2: t("termsOfUse.intro2"),
        terms: [
          {
            title: t("termsOfUse.terms.0.title"),
            desc: t("termsOfUse.terms.0.desc"),
          },
          {
            title: t("termsOfUse.terms.1.title"),
            desc: t("termsOfUse.terms.1.desc"),
          },
          {
            title: t("termsOfUse.terms.2.title"),
            desc: t("termsOfUse.terms.2.desc"),
            list: [
              t("termsOfUse.terms.2.list.0"),
              t("termsOfUse.terms.2.list.1"),
              t("termsOfUse.terms.2.list.2"),
              t("termsOfUse.terms.2.list.3"),
              t("termsOfUse.terms.2.list.4"),
            ],
          },
          {
            title: t("termsOfUse.terms.3.title"),
            desc: t("termsOfUse.terms.3.desc"),
          },
          {
            title: t("termsOfUse.terms.4.title"),
            desc: t("termsOfUse.terms.4.desc"),
          },
          {
            title: t("termsOfUse.terms.5.title"),
            desc: t("termsOfUse.terms.5.desc"),
          },
        ],
        contact: t("termsOfUse.contact"),
      },
      aboutUs: {
        header: t("aboutUs.header"),
        welcome: t("aboutUs.welcome"),
        tagline: t("aboutUs.tagline"),
        intro: t("aboutUs.intro"),
        missionTitle: t("aboutUs.missionTitle"),
        missionSubtitle: t("aboutUs.missionSubtitle"),
        missionText: t("aboutUs.missionText"),
        visionTitle: t("aboutUs.visionTitle"),
        visionSubtitle: t("aboutUs.visionSubtitle"),
        visionText: t("aboutUs.visionText"),
        whyTitle: t("aboutUs.whyTitle"),
        why1Bold: t("aboutUs.why1Bold"),
        why1: t("aboutUs.why1"),
        why2Bold: t("aboutUs.why2Bold"),
        why2: t("aboutUs.why2"),
        why3Bold: t("aboutUs.why3Bold"),
        why3: t("aboutUs.why3"),
        connectTitle: t("aboutUs.connectTitle"),
        connectText: t("aboutUs.connectText"),
        finalNote: t("aboutUs.finalNote"),
      },
      disclaimer: {
        title: t("disclaimer.title"),
        paragraphs: t("disclaimer.paragraphs", { returnObjects: true }),
      },
      historyData: {
        title: t("historyData.title"),
        no: t("historyData.no"),
        name: t("historyData.name"),
        totalInvestment: t("historyData.totalInvestment"),
        yearlyReturn: t("historyData.yearlyReturn"),
        noHistory: t("historyData.noHistory"),
        deleteConfirmation: t("historyData.deleteConfirmation"),
        delete: t("historyData.delete"),
        preview: t("historyData.preview"),
        yesDelete: t("historyData.yesDelete"),
        noKeep: t("historyData.noKeep"),
        titleData: t("historyData.titleData"),
        dataNotAvailable: t("historyData.dataNotAvailable"),
        downoadPDF: t("historyData.downoadPDF"),
      },
      lumpsumAmountModal: {
        title: t("lumpsumAmountModal.title"),
        noYear: t("lumpsumAmountModal.noYear"),
        noYearAmount: t("lumpsumAmountModal.noYearAmount"),
        totalYear: t("lumpsumAmountModal.totalYear"),
        totalAmount: t("lumpsumAmountModal.totalAmount"),
        addBtn: t("lumpsumAmountModal.addBtn"),
      },
      sipLumpsumCalc: {
        ageNumber: t("sipLumpsumCalc.ageNumber"),
        ageRequired: t("sipLumpsumCalc.ageRequired"),
        ageMin: t("sipLumpsumCalc.ageMin"),
        ageMax: t("sipLumpsumCalc.ageMax"),

        monthlyInvestmentRequired: t(
          "sipLumpsumCalc.monthlyInvestmentRequired",
        ),
        monthlyInvestmentNumber: t("sipLumpsumCalc.monthlyInvestmentNumber"),
        monthlyInvestmentMin: t("sipLumpsumCalc.monthlyInvestmentMin"),
        monthlyInvestmentMax: t("sipLumpsumCalc.monthlyInvestmentMax"),

        incrementPerYearNumber: t("sipLumpsumCalc.incrementPerYearNumber"),
        incrementPerYearMin: t("sipLumpsumCalc.incrementPerYearMin"),
        incrementPerYearMax: t("sipLumpsumCalc.incrementPerYearMax"),

        approxReturnRequired: t("sipLumpsumCalc.approxReturnRequired"),
        approxReturnNumber: t("sipLumpsumCalc.approxReturnNumber"),
        approxReturnMin: t("sipLumpsumCalc.approxReturnMin"),
        approxReturnMax: t("sipLumpsumCalc.approxReturnMax"),

        noOfInvestementYearRequired: t(
          "sipLumpsumCalc.noOfInvestementYearRequired",
        ),
        noOfInvestementYearNumber: t(
          "sipLumpsumCalc.noOfInvestementYearNumber",
        ),
        noOfInvestementYearMin: t("sipLumpsumCalc.noOfInvestementYearMin"),
        noOfInvestementYearMax: t("sipLumpsumCalc.noOfInvestementYearMax"),

        swpStartYearNumber: t("sipLumpsumCalc.swpStartYearNumber"),
        swpStartYearMin: t("sipLumpsumCalc.swpStartYearMin"),
        swpStartYearMax: t("sipLumpsumCalc.swpStartYearMax"),

        yearlyWithdrawNumber: t("sipLumpsumCalc.yearlyWithdrawNumber"),
        yearlyWithdrawMin: t("sipLumpsumCalc.yearlyWithdrawMin"),
        yearlyWithdrawMax: t("sipLumpsumCalc.yearlyWithdrawMax"),

        yearlyIncrementInWithdrawSwpNumber: t(
          "sipLumpsumCalc.yearlyIncrementInWithdrawSwpNumber",
        ),
        yearlyIncrementInWithdrawSwpMin: t(
          "sipLumpsumCalc.yearlyIncrementInWithdrawSwpMin",
        ),
        yearlyIncrementInWithdrawSwpMax: t(
          "sipLumpsumCalc.yearlyIncrementInWithdrawSwpMax",
        ),

        totalInvestmentRequired: t("sipLumpsumCalc.totalInvestmentRequired"),
        totalInvestmentNumber: t("sipLumpsumCalc.totalInvestmentNumber"),
        totalInvestmentMin: t("sipLumpsumCalc.totalInvestmentMin"),
        totalInvestmentMax: t("sipLumpsumCalc.totalInvestmentMax"),
      },
      cardsLabel: {
        sipDesciption: t("cardsLabel.sipDesciption"),
        calculateNow: t("cardsLabel.calculateNow"),
        propertyCalc: t("cardsLabel.propertyCalc"),
        propertyDescription: t("cardsLabel.propertyDescription"),
      },
      showMore: t("showMore"),
      popularCalculator: t("popularCalculator"),
      bussinessContent: {
        heading: t("bussinessContent.heading"),
        description: t("bussinessContent.description"),
        howItWorksHeading: t("bussinessContent.howItWorksHeading"),
        howItWorksDesc: t("bussinessContent.howItWorksDesc"),
        formula: t("bussinessContent.formula"),

        symbolTable: {
          headingSymbol: t("bussinessContent.symbolTable.headingSymbol"),
          headingDescription: t(
            "bussinessContent.symbolTable.headingDescription",
          ),
          symbols: {
            P: t("bussinessContent.symbolTable.symbols.P"),
            R: t("bussinessContent.symbolTable.symbols.R"),
            N: t("bussinessContent.symbolTable.symbols.N"),
          },
        },

        benefitsHeading: t("bussinessContent.benefitsHeading"),
        benefitsList: [
          t("bussinessContent.benefitsList.0"),
          t("bussinessContent.benefitsList.1"),
          t("bussinessContent.benefitsList.2"),
          t("bussinessContent.benefitsList.3"),
          t("bussinessContent.benefitsList.4"),
        ],

        exampleHeading: t("bussinessContent.exampleHeading"),
        exampleDesc: t("bussinessContent.exampleDesc"),

        amortizationHeading: t("bussinessContent.amortizationHeading"),
        amortizationDesc: t("bussinessContent.amortizationDesc"),
      },
      carLeaseContent: {
        title: t("carLeaseContent.title"),
        description: t("carLeaseContent.description"),

        howItWorksTitle: t("carLeaseContent.howItWorksTitle"),
        howItWorksDescription: t("carLeaseContent.howItWorksDescription"),

        emiFormulaLabel: t("carLeaseContent.emiFormulaLabel"),
        emiFormula: t("carLeaseContent.emiFormula"),
        buy: t("carLeaseContent.buy"),
        lease: t("carLeaseContent.lease"),
        maintenance: t("carLeaseContent.maintenance"),
        mileage: t("carLeaseContent.mileage"),
        onPay: t("carLeaseContent.onPay"),

        symbolTable: {
          symbolColumn: t("carLeaseContent.symbolTable.symbolColumn"),
          descriptionColumn: t("carLeaseContent.symbolTable.descriptionColumn"),
          p: t("carLeaseContent.symbolTable.p"),
          r: t("carLeaseContent.symbolTable.r"),
          n: t("carLeaseContent.symbolTable.n"),
        },

        upfrontCostsTitle: t("carLeaseContent.upfrontCostsTitle"),
        upfrontCostsDescription: {
          buying: t("carLeaseContent.upfrontCostsDescription.buying"),
          leasing: t("carLeaseContent.upfrontCostsDescription.leasing"),
        },

        additionalExpensesTitle: t("carLeaseContent.additionalExpensesTitle"),
        additionalExpenses: {
          maintenance: t("carLeaseContent.additionalExpenses.maintenance"),
          mileageLimits: t("carLeaseContent.additionalExpenses.mileageLimits"),
          ongoingPayments: t(
            "carLeaseContent.additionalExpenses.ongoingPayments",
          ),
        },

        whyBuyingCostsMoreTitle: t("carLeaseContent.whyBuyingCostsMoreTitle"),
        whyBuyingCostsMoreDescription: t(
          "carLeaseContent.whyBuyingCostsMoreDescription",
        ),

        benefitsTitle: t("carLeaseContent.benefitsTitle"),
        benefitsList: [
          t("carLeaseContent.benefitsList.0"),
          t("carLeaseContent.benefitsList.1"),
          t("carLeaseContent.benefitsList.2"),
          t("carLeaseContent.benefitsList.3"),
        ],
      },
      contrubutionContent: {
        title: t("contrubutionContent.title"),
        description: t("contrubutionContent.description"),

        howItWorksTitle: t("contrubutionContent.howItWorksTitle"),
        howItWorksDescription: t("contrubutionContent.howItWorksDescription"),

        fvFormulaLabel: t("contrubutionContent.fvFormulaLabel"),
        empMatch: t("contrubutionContent.empMatch"),
        taxMatch: t("contrubutionContent.taxMatch"),
        vestPeriod: t("contrubutionContent.vestPeriod"),
        contribuionLimit: t("contrubutionContent.contribuionLimit"),

        symbolTable: {
          symbolColumn: t("contrubutionContent.symbolTable.symbolColumn"),
          descriptionColumn: t(
            "contrubutionContent.symbolTable.descriptionColumn",
          ),
          FV: t("contrubutionContent.symbolTable.FV"),
          P: t("contrubutionContent.symbolTable.P"),
          r: t("contrubutionContent.symbolTable.r"),
          n: t("contrubutionContent.symbolTable.n"),
          PMT: t("contrubutionContent.symbolTable.PMT"),
        },

        featuresTitle: t("contrubutionContent.featuresTitle"),
        featuresList: [
          t("contrubutionContent.featuresList.0"),
          t("contrubutionContent.featuresList.1"),
          t("contrubutionContent.featuresList.2"),
          t("contrubutionContent.featuresList.3"),
        ],

        withdrawalRulesTitle: t("contrubutionContent.withdrawalRulesTitle"),
        withdrawalRulesDescription: t(
          "contrubutionContent.withdrawalRulesDescription",
        ),

        benefitsTitle: t("contrubutionContent.benefitsTitle"),
        benefitsList: [
          t("contrubutionContent.benefitsList.0"),
          t("contrubutionContent.benefitsList.1"),
          t("contrubutionContent.benefitsList.2"),
          t("contrubutionContent.benefitsList.3"),
          t("contrubutionContent.benefitsList.4"),
        ],
      },
      creditContent: {
        title: t("creditContent.title"),
        description: t("creditContent.description"),

        howItWorksTitle: t("creditContent.howItWorksTitle"),
        howItWorksDescription: t("creditContent.howItWorksDescription"),
        interestFormulaLabel: t("creditContent.interestFormulaLabel"),
        howItWorksDescription2: t("creditContent.howItWorksDescription2"),
        inputsRequiredTitle: t("creditContent.inputsRequiredTitle"),
        inputsTable: {
          symbolColumn: t("creditContent.inputsTable.symbolColumn"),
          descriptionColumn: t("creditContent.inputsTable.descriptionColumn"),
          balance: t("creditContent.inputsTable.balance"),
          intrest: t("creditContent.inputsTable.intrest"),
          OutstandingBalance: t("creditContent.inputsTable.OutstandingBalance"),
          MonthlyInterest: t("creditContent.inputsTable.MonthlyInterest"),
          monthlyPay: t("creditContent.inputsTable.monthlyPay"),
          MonthlyPayment: t("creditContent.inputsTable.MonthlyPayment"),
        },

        debt: t("creditContent.debt"),
        avalance: t("creditContent.avalance"),
        console: t("creditContent.console"),

        resultsTitle: t("creditContent.resultsTitle"),
        resultsList: [
          t("creditContent.resultsList.0"),
          t("creditContent.resultsList.1"),
          t("creditContent.resultsList.2"),
          t("creditContent.resultsList.3"),
          t("creditContent.resultsList.4"),
        ],
        useTitle: t("creditContent.useTitle"),
        useList: [
          t("creditContent.useList.0"),
          t("creditContent.useList.1"),
          t("creditContent.useList.2"),
          t("creditContent.useList.3"),
          t("creditContent.useList.4"),
        ],

        strategiesTitle: t("creditContent.strategiesTitle"),
        strategiesList: [
          t("creditContent.strategiesList.0"),
          t("creditContent.strategiesList.1"),
          t("creditContent.strategiesList.2"),
        ],

        importanceTitle: t("creditContent.importanceTitle"),
        importanceList: [
          t("creditContent.importanceList.0"),
          t("creditContent.importanceList.1"),
          t("creditContent.importanceList.2"),
          t("creditContent.importanceList.3"),
        ],
      },
      debtContent: {
        title: t("debtContent.title"),

        description: [
          t("debtContent.description.0"),
          t("debtContent.description.1"),
        ],

        howItWorksTitle: t("debtContent.howItWorksTitle"),
        howItWorksSteps: [
          t("debtContent.howItWorksSteps.0"),
          t("debtContent.howItWorksSteps.1"),
          t("debtContent.howItWorksSteps.2"),
        ],

        inputsTable: {
          symbolColumn: t("debtContent.inputsTable.symbolColumn"),
          descriptionColumn: t("debtContent.inputsTable.descriptionColumn"),
          MonthlyIncome: t("debtContent.inputsTable.MonthlyIncome"),
          TotalMonthlyDebt: t("debtContent.inputsTable.TotalMonthlyDebt"),
        },
        monthlyIncome: t("debtContent.monthlyIncome"),
        totalDebt: t("debtContent.totalDebt"),
        front: t("debtContent.front"),
        backend: t("debtContent.backend"),

        typesTitle: t("debtContent.typesTitle"),
        typesList: {
          frontEnd: t("debtContent.typesList.frontEnd"),
          backEnd: t("debtContent.typesList.backEnd"),
        },

        benefitsTitle: t("debtContent.benefitsTitle"),
        benefitsList: [
          t("debtContent.benefitsList.0"),
          t("debtContent.benefitsList.1"),
          t("debtContent.benefitsList.2"),
          t("debtContent.benefitsList.3"),
        ],

        improveTitle: t("debtContent.improveTitle"),
        improveList: [
          t("debtContent.improveList.0"),
          t("debtContent.improveList.1"),
          t("debtContent.improveList.2"),
          t("debtContent.improveList.3"),
        ],

        classificationTitle: t("debtContent.classificationTitle"),
        below: t("debtContent.below"),
        Above: t("debtContent.Above"),
        classificationList: [
          t("debtContent.classificationList.0"),
          t("debtContent.classificationList.1"),
          t("debtContent.classificationList.2"),
          t("debtContent.classificationList.3"),
        ],
      },
      earlyContent: {
        title: t("earlyContent.title"),
        description: t("earlyContent.description"),

        howItWorksTitle: t("earlyContent.howItWorksTitle"),
        howItWorksSteps: t("earlyContent.howItWorksSteps"),
        formula: t("earlyContent.formula"),

        inputsTable: {
          symbolColumn: t("earlyContent.inputsTable.symbolColumn"),
          descriptionColumn: t("earlyContent.inputsTable.descriptionColumn"),
          P: t("earlyContent.inputsTable.P"),
          r: t("earlyContent.inputsTable.r"),
          n: t("earlyContent.inputsTable.n"),
        },

        outstandingLoan: t("earlyContent.outstandingLoan"),
        loanTenture: t("earlyContent.loanTenture"),
        inpRate: t("earlyContent.inpRate"),
        prepayment: t("earlyContent.prepayment"),
        calculate: t("earlyContent.calculate"),
        saveIntrest: t("earlyContent.saveIntrest"),
        reduceTenure: t("earlyContent.reduceTenure"),
        flexPlan: t("earlyContent.flexPlan"),
        InstantResults: t("earlyContent.InstantResults:"),
        InformedDecisions: t("earlyContent.InformedDecisions:"),
        earlyYear: t("earlyContent.earlyYear"),
        afterWindfall: t("earlyContent.afterWindfall"),
        complareOpt: t("earlyContent.complareOpt"),
        RegularReviews: t("earlyContent.RegularReviews:"),
        futureNeed: t("earlyContent.futureNeed"),
        taxBenifits: t("earlyContent.taxBenifits"),
        investAlt: t("earlyContent.investAlt:"),
        emiTnture: t("earlyContent.emiTnture"),

        stepsToUseTitle: t("earlyContent.stepsToUseTitle"),
        stepsToUse: [
          t("earlyContent.stepsToUse.0"),
          t("earlyContent.stepsToUse.1"),
          t("earlyContent.stepsToUse.2"),
          t("earlyContent.stepsToUse.3"),
          t("earlyContent.stepsToUse.4"),
        ],

        benefitsTitle: t("earlyContent.benefitsTitle"),
        benefitsList: [
          t("earlyContent.benefitsList.0"),
          t("earlyContent.benefitsList.1"),
          t("earlyContent.benefitsList.2"),
          t("earlyContent.benefitsList.3"),
          t("earlyContent.benefitsList.4"),
        ],

        scenario: t("earlyContent.scenario"),
        whenToUseTitle: t("earlyContent.whenToUseTitle"),
        whenToUseList: [
          t("earlyContent.whenToUseList.0"),
          t("earlyContent.whenToUseList.1"),
          t("earlyContent.whenToUseList.2"),
          t("earlyContent.whenToUseList.3"),
        ],

        considerationsTitle: t("earlyContent.considerationsTitle"),
        considerationsList: [
          t("earlyContent.considerationsList.0"),
          t("earlyContent.considerationsList.1"),
          t("earlyContent.considerationsList.2"),
          t("earlyContent.considerationsList.3"),
        ],
      },
      educationContent: {
        title: t("educationContent.title"),
        description: t("educationContent.description"),

        howItHelpsTitle: t("educationContent.howItHelpsTitle"),
        howItHelpsDescription: t("educationContent.howItHelpsDescription"),
        howItHelpsList: [
          t("educationContent.howItHelpsList.0"),
          t("educationContent.howItHelpsList.1"),
          t("educationContent.howItHelpsList.2"),
          t("educationContent.howItHelpsList.3"),
        ],
        followingDetail: t("educationContent.followingDetail"),
        formulaDes: t("educationContent.formulaDes"),

        howToUseTitle: t("educationContent.howToUseTitle"),
        howToUseList: [
          {
            label: t("educationContent.howToUseList.0.label"),
            description: t("educationContent.howToUseList.0.description"),
          },
          {
            label: t("educationContent.howToUseList.1.label"),
            description: t("educationContent.howToUseList.1.description"),
          },
          {
            label: t("educationContent.howToUseList.2.label"),
            description: t("educationContent.howToUseList.2.description"),
          },
        ],
        howToUseSummary: t("educationContent.howToUseSummary"),

        formulaTitle: t("educationContent.formulaTitle"),
        formula: t("educationContent.formula"),
        formulaParameters: {
          P: t("educationContent.formulaParameters.P"),
          R: t("educationContent.formulaParameters.R"),
          N: t("educationContent.formulaParameters.N"),
        },

        exampleTitle: t("educationContent.exampleTitle"),
        exampleDec: t("educationContent.exampleDec"),
        example: {
          LoanAmt: t("educationContent.example.LoanAmt"),
          RateInt: t("educationContent.example.RateInt"),
          Tenure: t("educationContent.example.Tenure"),
          EMI: t("educationContent.example.EMI"),
          approx: t("educationContent.example.approx"),
          annually: t("educationContent.example.annually"),
          monthly: t("educationContent.example.monthly"),
          years: t("educationContent.example.years"),
          months: t("educationContent.example.months"),
        },

        benefitsTitle: t("educationContent.benefitsTitle"),
        benefitsList: [
          t("educationContent.benefitsList.0"),
          t("educationContent.benefitsList.1"),
          t("educationContent.benefitsList.2"),
          t("educationContent.benefitsList.3"),
          t("educationContent.benefitsList.4"),
        ],
      },
      fdContent: {
        title: t("fdContent.title"),
        description: t("fdContent.description"),

        howItWorksTitle: t("fdContent.howItWorksTitle"),
        howItWorksDescription: t("fdContent.howItWorksDescription"),
        formula: t("fdContent.formula"),
        formulaDescription: {
          P: t("fdContent.formulaDescription.P"),
          r: t("fdContent.formulaDescription.r"),
          n: t("fdContent.formulaDescription.n"),
          t: t("fdContent.formulaDescription.t"),
        },

        symbolColumn: t("fdContent.symbolColumn"),
        descriptionColumn: t("fdContent.descriptionColumn"),

        benefitsTitle: t("fdContent.benefitsTitle"),
        benefitsList: [
          t("fdContent.benefitsList.0"),
          t("fdContent.benefitsList.1"),
          t("fdContent.benefitsList.2"),
          t("fdContent.benefitsList.3"),
          t("fdContent.benefitsList.4"),
          t("fdContent.benefitsList.5"),
        ],
        return: t("fdContent.return"),
        exampleTitle: t("fdContent.exampleTitle"),
        exampleDescription: t("fdContent.exampleDescription"),
        exampleFormula: t("fdContent.exampleFormula"),
        exampleValues: [
          {
            label: t("fdContent.exampleValues.0.label"),
          },
          {
            label: t("fdContent.exampleValues.1.label"),
          },
          {
            label: t("fdContent.exampleValues.2.label"),
          },
        ],
      },
      gstContent: {
        title: t("gstContent.title"),
        description: t("gstContent.description"),

        howItWorksTitle: t("gstContent.howItWorksTitle"),
        howItWorksDescription: t("gstContent.howItWorksDescription"),
        tax: t("gstContent.tax"),
        gst: t("gstContent.gst"),
        finalPrice: t("gstContent.FinalPrice"),
        removeInc: t("gstContent.removeInc"),
        basePrice: t("gstContent.basePrice"),

        exclusive: {
          gstAmount: t("gstContent.exclusive.gstAmount"),
          finalPrice: t("gstContent.exclusive.finalPrice"),
        },

        inclusive: {
          gstAmount: t("gstContent.inclusive.gstAmount"),
          basePrice: t("gstContent.inclusive.basePrice"),
        },

        symbole: t("gstContent.symbole"),
        syDescription: t("gstContent.syDescription"),

        symbolsTable: [
          {
            symbol: t("gstContent.symbolsTable.0.symbol"),
            description: t("gstContent.symbolsTable.0.description"),
          },
          {
            symbol: t("gstContent.symbolsTable.1.symbol"),
            description: t("gstContent.symbolsTable.1.description"),
          },
          {
            symbol: t("gstContent.symbolsTable.2.symbol"),
            description: t("gstContent.symbolsTable.2.description"),
          },
        ],

        gstVatTypesTitle: t("gstContent.gstVatTypesTitle"),
        gstVatTypes: [
          {
            type: t("gstContent.gstVatTypes.0.type"),
            description: t("gstContent.gstVatTypes.0.description"),
          },
          {
            type: t("gstContent.gstVatTypes.1.type"),
            description: t("gstContent.gstVatTypes.1.description"),
          },
        ],

        exampleTitle: t("gstContent.exampleTitle"),
        Exclusive: t("gstContent.Exclusive"),
        Inclusive: t("gstContent.Inclusive"),
        exContent: t("gstContent.exContent"),
        benefitsTitle: t("gstContent.benefitsTitle"),
        benefitsList: [
          t("gstContent.benefitsList.0"),
          t("gstContent.benefitsList.1"),
          t("gstContent.benefitsList.2"),
          t("gstContent.benefitsList.3"),
          t("gstContent.benefitsList.4"),
        ],
      },
      ltvContent: {
        title: t("ltvContent.title"),
        description: t("ltvContent.description"),

        howItWorksTitle: t("ltvContent.howItWorksTitle"),
        howItWorksDescription: t("ltvContent.howItWorksDescription"),
        ltvFormula: t("ltvContent.ltvFormula"),
        ltvFormulaDescription: t("ltvContent.ltvFormulaDescription"),

        symbolColumn: t("ltvContent.symbolColumn"),
        descriptionColumn: t("ltvContent.descriptionColumn"),

        emiFormula: t("ltvContent.emiFormula"),

        symbolsTable: {
          descriptionP: t("ltvContent.symbolsTable.descriptionP"),
          descriptionM: t("ltvContent.symbolsTable.descriptionM"),
          descriptionL: t("ltvContent.symbolsTable.descriptionL"),
        },

        howToUseTitle: t("ltvContent.howToUseTitle"),
        howToUseSteps: [
          t("ltvContent.howToUseSteps.0"),
          t("ltvContent.howToUseSteps.1"),
          t("ltvContent.howToUseSteps.2"),
          t("ltvContent.howToUseSteps.3"),
          t("ltvContent.howToUseSteps.4"),
          t("ltvContent.howToUseSteps.5"),
        ],

        factorsAffectingLtvTitle: t("ltvContent.factorsAffectingLtvTitle"),
        factorsAffectingLtv: [
          {
            factor: t("ltvContent.factorsAffectingLtv.0.factor"),
            description: t("ltvContent.factorsAffectingLtv.0.description"),
          },
          {
            factor: t("ltvContent.factorsAffectingLtv.1.factor"),
            description: t("ltvContent.factorsAffectingLtv.1.description"),
          },
          {
            factor: t("ltvContent.factorsAffectingLtv.2.factor"),
            description: t("ltvContent.factorsAffectingLtv.2.description"),
          },
          {
            factor: t("ltvContent.factorsAffectingLtv.3.factor"),
            description: t("ltvContent.factorsAffectingLtv.3.description"),
          },
          {
            factor: t("ltvContent.factorsAffectingLtv.4.factor"),
            description: t("ltvContent.factorsAffectingLtv.4.description"),
          },
          {
            factor: t("ltvContent.factorsAffectingLtv.5.factor"),
            description: t("ltvContent.factorsAffectingLtv.5.description"),
          },
        ],

        benefitsTitle: t("ltvContent.benefitsTitle"),
        benefitsList: [
          t("ltvContent.benefitsList.0"),
          t("ltvContent.benefitsList.1"),
          t("ltvContent.benefitsList.2"),
          t("ltvContent.benefitsList.3"),
          t("ltvContent.benefitsList.4"),
        ],

        tipTitle: t("ltvContent.tipTitle"),
        tipContent: t("ltvContent.tipContent"),
      },
      morgageContent: {
        title: t("morgageContent.title"),
        description: t("morgageContent.description"),
        howItWorksTitle: t("morgageContent.howItWorksTitle"),
        howItWorksDescription: t("morgageContent.howItWorksDescription"),
        mortgageFormulaLabel: t("morgageContent.mortgageFormulaLabel"),
        symbolColumn: t("morgageContent.symbolColumn"),
        descriptionColumn: t("morgageContent.descriptionColumn"),
        formulaSymbolTableTitle: t("morgageContent.formulaSymbolTableTitle"),

        formulaSymbols: [
          {
            symbol: t("morgageContent.formulaSymbols.0.symbol"),
            description: t("morgageContent.formulaSymbols.0.description"),
          },
          {
            symbol: t("morgageContent.formulaSymbols.1.symbol"),
            description: t("morgageContent.formulaSymbols.1.description"),
          },
          {
            symbol: t("morgageContent.formulaSymbols.2.symbol"),
            description: t("morgageContent.formulaSymbols.2.description"),
          },
          {
            symbol: t("morgageContent.formulaSymbols.3.symbol"),
            description: t("morgageContent.formulaSymbols.3.description"),
          },
        ],

        howToUseMortgageCalculatorTitle: t(
          "morgageContent.howToUseMortgageCalculatorTitle",
        ),
        howToUseMortgageCalculatorSteps: [
          {
            detail: t(
              "morgageContent.howToUseMortgageCalculatorSteps.0.detail",
            ),
            description: t(
              "morgageContent.howToUseMortgageCalculatorSteps.0.description",
            ),
          },
          {
            detail: t(
              "morgageContent.howToUseMortgageCalculatorSteps.1.detail",
            ),
            description: t(
              "morgageContent.howToUseMortgageCalculatorSteps.1.description",
            ),
          },
          {
            detail: t(
              "morgageContent.howToUseMortgageCalculatorSteps.2.detail",
            ),
            description: t(
              "morgageContent.howToUseMortgageCalculatorSteps.2.description",
            ),
          },
          {
            detail: t(
              "morgageContent.howToUseMortgageCalculatorSteps.3.detail",
            ),
            description: t(
              "morgageContent.howToUseMortgageCalculatorSteps.3.description",
            ),
          },
        ],

        benefitsOfMortgageCalculatorTitle: t(
          "morgageContent.benefitsOfMortgageCalculatorTitle",
        ),
        benefitsOfMortgageCalculator: [
          {
            title: t("morgageContent.benefitsOfMortgageCalculator.0.title"),
            description: t(
              "morgageContent.benefitsOfMortgageCalculator.0.description",
            ),
          },
          {
            title: t("morgageContent.benefitsOfMortgageCalculator.1.title"),
            description: t(
              "morgageContent.benefitsOfMortgageCalculator.1.description",
            ),
          },
          {
            title: t("morgageContent.benefitsOfMortgageCalculator.2.title"),
            description: t(
              "morgageContent.benefitsOfMortgageCalculator.2.description",
            ),
          },
          {
            title: t("morgageContent.benefitsOfMortgageCalculator.3.title"),
            description: t(
              "morgageContent.benefitsOfMortgageCalculator.3.description",
            ),
          },
          {
            title: t("morgageContent.benefitsOfMortgageCalculator.4.title"),
            description: t(
              "morgageContent.benefitsOfMortgageCalculator.4.description",
            ),
          },
        ],

        keyConsiderationsMortgageTitle: t(
          "morgageContent.keyConsiderationsMortgageTitle",
        ),
        keyConsiderationsMortgage: [
          {
            factor: t("morgageContent.keyConsiderationsMortgage.0.factor"),
            description: t(
              "morgageContent.keyConsiderationsMortgage.0.description",
            ),
          },
          {
            factor: t("morgageContent.keyConsiderationsMortgage.1.factor"),
            description: t(
              "morgageContent.keyConsiderationsMortgage.1.description",
            ),
          },
          {
            factor: t("morgageContent.keyConsiderationsMortgage.2.factor"),
            description: t(
              "morgageContent.keyConsiderationsMortgage.2.description",
            ),
          },
          {
            factor: t("morgageContent.keyConsiderationsMortgage.3.factor"),
            description: t(
              "morgageContent.keyConsiderationsMortgage.3.description",
            ),
          },
          {
            factor: t("morgageContent.keyConsiderationsMortgage.4.factor"),
            description: t(
              "morgageContent.keyConsiderationsMortgage.4.description",
            ),
          },
        ],
      },
      netWorthContent: {
        title: t("netWorthContent.title"),
        description: t("netWorthContent.description"),

        howItWorksTitle: t("netWorthContent.howItWorksTitle"),
        howItWorksDescription: t("netWorthContent.howItWorksDescription"),
        formula: t("netWorthContent.formula"),
        formulaDec: t("netWorthContent.formulaDec"),
        breakDown: t("netWorthContent.breakDown"),
        breckdownDec: t("netWorthContent.breckdownDec"),
        exFormula: t("netWorthContent.exFormula"),
        assetTypesTitle: t("netWorthContent.assetTypesTitle"),
        assetType: t("netWorthContent.assetType"),
        examples: t("netWorthContent.examples"),

        assetTypesTable: [
          {
            type: t("netWorthContent.assetTypesTable.0.type"),
            examples: t("netWorthContent.assetTypesTable.0.examples"),
          },
          {
            type: t("netWorthContent.assetTypesTable.1.type"),
            examples: t("netWorthContent.assetTypesTable.1.examples"),
          },
          {
            type: t("netWorthContent.assetTypesTable.2.type"),
            examples: t("netWorthContent.assetTypesTable.2.examples"),
          },
          {
            type: t("netWorthContent.assetTypesTable.3.type"),
            examples: t("netWorthContent.assetTypesTable.3.examples"),
          },
          {
            type: t("netWorthContent.assetTypesTable.4.type"),
            examples: t("netWorthContent.assetTypesTable.4.examples"),
          },
          {
            type: t("netWorthContent.assetTypesTable.5.type"),
            examples: t("netWorthContent.assetTypesTable.5.examples"),
          },
        ],

        liabilityTypesTitle: t("netWorthContent.liabilityTypesTitle"),
        liabilityType: t("netWorthContent.liabilityType"),

        liabilityTypesTable: [
          {
            type: t("netWorthContent.liabilityTypesTable.0.type"),
            examples: t("netWorthContent.liabilityTypesTable.0.examples"),
          },
          {
            type: t("netWorthContent.liabilityTypesTable.1.type"),
            examples: t("netWorthContent.liabilityTypesTable.1.examples"),
          },
          {
            type: t("netWorthContent.liabilityTypesTable.2.type"),
            examples: t("netWorthContent.liabilityTypesTable.2.examples"),
          },
          {
            type: t("netWorthContent.liabilityTypesTable.3.type"),
            examples: t("netWorthContent.liabilityTypesTable.3.examples"),
          },
          {
            type: t("netWorthContent.liabilityTypesTable.4.type"),
            examples: t("netWorthContent.liabilityTypesTable.4.examples"),
          },
          {
            type: t("netWorthContent.liabilityTypesTable.5.type"),
            examples: t("netWorthContent.liabilityTypesTable.5.examples"),
          },
        ],
        benifit: t("netWorthContent.benifit"),
        benifitDec: [
          t("netWorthContent.benifitDec.0"),
          t("netWorthContent.benifitDec.1"),
          t("netWorthContent.benifitDec.2"),
          t("netWorthContent.benifitDec.3"),
          t("netWorthContent.benifitDec.4"),
        ],
        networth: t("netWorthContent.networth"),
        networthDec: [
          {
            value: t("netWorthContent.networthDec.0.value"),
            dec: t("netWorthContent.networthDec.0.dec"),
          },
          {
            value: t("netWorthContent.networthDec.1.value"),
            dec: t("netWorthContent.networthDec.1.dec"),
          },
        ],

        exampleCalculationTitle: t("netWorthContent.exampleCalculationTitle"),
        exampleCalculationStep1: t("netWorthContent.exampleCalculationStep1"),
        exampleCalculationStep2: t("netWorthContent.exampleCalculationStep2"),
        descaimber: t("netWorthContent.descaimber"),
        dec: t("netWorthContent.dec"),
      },
      pensionContent: {
        title: t("pensionContent.title"),
        description: t("pensionContent.description"),

        howItWorksTitle: t("pensionContent.howItWorksTitle"),
        howItWorksDescription: t("pensionContent.howItWorksDescription"),

        calculationPoints: [
          {
            label: t("pensionContent.calculationPoints.0.label"),
            description: t("pensionContent.calculationPoints.0.description"),
          },
          {
            label: t("pensionContent.calculationPoints.1.label"),
            description: t("pensionContent.calculationPoints.1.description"),
          },
          {
            label: t("pensionContent.calculationPoints.2.label"),
            description: t("pensionContent.calculationPoints.2.description"),
          },
          {
            label: t("pensionContent.calculationPoints.3.label"),
            description: t("pensionContent.calculationPoints.3.description"),
          },
          {
            label: t("pensionContent.calculationPoints.4.label"),
            description: t("pensionContent.calculationPoints.4.description"),
          },
          {
            label: t("pensionContent.calculationPoints.5.label"),
            description: t("pensionContent.calculationPoints.5.description"),
          },
        ],

        formula: t("pensionContent.formula"),
        formulaNote: t("pensionContent.formulaNote"),

        keyBenefitsTitle: t("pensionContent.keyBenefitsTitle"),
        keyBenefits: [
          {
            label: t("pensionContent.keyBenefits.0.label"),
            description: t("pensionContent.keyBenefits.0.description"),
          },
          {
            label: t("pensionContent.keyBenefits.1.label"),
            description: t("pensionContent.keyBenefits.1.description"),
          },
          {
            label: t("pensionContent.keyBenefits.2.label"),
            description: t("pensionContent.keyBenefits.2.description"),
          },
          {
            label: t("pensionContent.keyBenefits.3.label"),
            description: t("pensionContent.keyBenefits.3.description"),
          },
          {
            label: t("pensionContent.keyBenefits.4.label"),
            description: t("pensionContent.keyBenefits.4.description"),
          },
        ],

        howToUseTitle: t("pensionContent.howToUseTitle"),
        howToUseSteps: [
          t("pensionContent.howToUseSteps.0"),
          t("pensionContent.howToUseSteps.1"),
          t("pensionContent.howToUseSteps.2"),
          t("pensionContent.howToUseSteps.3"),
        ],

        whyStartEarlyTitle: t("pensionContent.whyStartEarlyTitle"),
        whyStartEarlyDescription: t("pensionContent.whyStartEarlyDescription"),

        tip: t("pensionContent.tip"),
        tipDetail: t("pensionContent.tipDetail"),
      },
      personalContent: {
        title: t("personalContent.title"),
        description: t("personalContent.description"),

        howItWorksTitle: t("personalContent.howItWorksTitle"),
        howItWorksDescription: t("personalContent.howItWorksDescription"),

        emiFormula: t("personalContent.emiFormula"),
        symbolColumn: t("personalContent.symbolColumn"),
        descriptionColumn: t("personalContent.descriptionColumn"),
        emiSymbolsTable: [
          {
            symbol: t("personalContent.emiSymbolsTable.0.symbol"),
            description: t("personalContent.emiSymbolsTable.0.description"),
          },
          {
            symbol: t("personalContent.emiSymbolsTable.1.symbol"),
            description: t("personalContent.emiSymbolsTable.1.description"),
          },
          {
            symbol: t("personalContent.emiSymbolsTable.2.symbol"),
            description: t("personalContent.emiSymbolsTable.2.description"),
          },
        ],

        benefitsTitle: t("personalContent.benefitsTitle"),
        benefits: [
          t("personalContent.benefits.0"),
          t("personalContent.benefits.1"),
          t("personalContent.benefits.2"),
          t("personalContent.benefits.3"),
          t("personalContent.benefits.4"),
        ],
        exampleCalc: t("personalContent.exampleCalc"),
        exampleDDec: t("personalContent.exampleDDec"),
        scedule: t("personalContent.scedule"),
        sceduleDec: t("personalContent.sceduleDec"),
      },
      rdContent: {
        title: t("rdContent.title"),
        description: t("rdContent.description"),

        howItWorksTitle: t("rdContent.howItWorksTitle"),
        howItWorksDescription: t("rdContent.howItWorksDescription"),

        rdFormula: t("rdContent.rdFormula"),
        formulaDescription: t("rdContent.formulaDescription"),

        rdSymbolsTable: [
          {
            symbol: t("rdContent.rdSymbolsTable.0.symbol"),
            description: t("rdContent.rdSymbolsTable.0.description"),
          },
          {
            symbol: t("rdContent.rdSymbolsTable.1.symbol"),
            description: t("rdContent.rdSymbolsTable.1.description"),
          },
          {
            symbol: t("rdContent.rdSymbolsTable.2.symbol"),
            description: t("rdContent.rdSymbolsTable.2.description"),
          },
          {
            symbol: t("rdContent.rdSymbolsTable.3.symbol"),
            description: t("rdContent.rdSymbolsTable.3.description"),
          },
        ],
        exampleCalc: t("rdContent.exampleCalc"),
        exampleDec: t("rdContent.exampleDec"),
        calculation: [
          {
            label: t("rdContent.calculation.0.label"),
            value: t("rdContent.calculation.0.value"),
          },
          {
            label: t("rdContent.calculation.1.label"),
            value: t("rdContent.calculation.1.value"),
          },
          {
            label: t("rdContent.calculation.2.label"),
            value: t("rdContent.calculation.2.value"),
          },
        ],
        intrestDec: t("rdContent.intrestDec"),
        benefitsTitle: t("rdContent.benefitsTitle"),
        benefits: [
          t("rdContent.benefits.0"),
          t("rdContent.benefits.1"),
          t("rdContent.benefits.2"),
          t("rdContent.benefits.3"),
          t("rdContent.benefits.4"),
        ],

        exampleTitle: t("rdContent.exampleTitle"),
        exampleDescription: t("rdContent.exampleDescription"),

        rdExampleFormula: t("rdContent.rdExampleFormula"),

        rdExampleDetails: [
          {
            label: t("rdContent.rdExampleDetails.0.label"),
            value: t("rdContent.rdExampleDetails.0.value"),
          },
          {
            label: t("rdContent.rdExampleDetails.1.label"),
            value: t("rdContent.rdExampleDetails.1.value"),
          },
          {
            label: t("rdContent.rdExampleDetails.2.label"),
            value: t("rdContent.rdExampleDetails.2.value"),
          },
        ],

        compoundingDescription: t("rdContent.compoundingDescription"),
      },
      salaryContent: {
        title: t("salaryContent.title"),
        description: t("salaryContent.description"),

        workdescription: t("salaryContent.workdescription"),
        howItWorksDescription: t("salaryContent.howItWorksDescription"),
        howItWorksAdditionalDescription: t(
          "salaryContent.howItWorksAdditionalDescription",
        ),

        formula: t("salaryContent.formula"),
        salaryFormula: t("salaryContent.salaryFormula"),

        htscSymbolsTable: [
          {
            symbol: t("salaryContent.htscSymbolsTable.0.symbol"),
            description: t("salaryContent.htscSymbolsTable.0.description"),
          },
          {
            symbol: t("salaryContent.htscSymbolsTable.1.symbol"),
            description: t("salaryContent.htscSymbolsTable.1.description"),
          },
          {
            symbol: t("salaryContent.htscSymbolsTable.2.symbol"),
            description: t("salaryContent.htscSymbolsTable.2.description"),
          },
        ],

        hour: t("salaryContent.hour"),

        exampleTitle: t("salaryContent.exampleTitle"),
        exampleDescription: t("salaryContent.exampleDescription"),

        exampleDetails: [
          {
            label: t("salaryContent.exampleDetails.0.label"),
          },
          {
            label: t("salaryContent.exampleDetails.1.label"),
          },
          {
            label: t("salaryContent.exampleDetails.2.label"),
          },
        ],

        notesTitle: t("salaryContent.notesTitle"),
        notes: [
          t("salaryContent.notes.0"),
          t("salaryContent.notes.1"),
          t("salaryContent.notes.2"),
        ],

        benefitsTitle: t("salaryContent.benefitsTitle"),
        benefits: [
          t("salaryContent.benefits.0"),
          t("salaryContent.benefits.1"),
          t("salaryContent.benefits.2"),
          t("salaryContent.benefits.3"),
        ],
      },
      savingContent: {
        title: t("savingContent.title"),
        description: t("savingContent.description"),

        howItWorksTitle: t("savingContent.howItWorksTitle"),
        howItWorksDescription: t("savingContent.howItWorksDescription"),
        formula: t("savingContent.formula"),

        exampleDescription: t("savingContent.exampleDescription"),

        symbolColumn: t("savingContent.symbolColumn"),
        descriptionColumn: t("savingContent.descriptionColumn"),

        sgcSymbolsTable: [
          {
            symbol: t("savingContent.sgcSymbolsTable.0.symbol"),
            description: t("savingContent.sgcSymbolsTable.0.description"),
          },
          {
            symbol: t("savingContent.sgcSymbolsTable.1.symbol"),
            description: t("savingContent.sgcSymbolsTable.1.description"),
          },
          {
            symbol: t("savingContent.sgcSymbolsTable.2.symbol"),
            description: t("savingContent.sgcSymbolsTable.2.description"),
          },
          {
            symbol: t("savingContent.sgcSymbolsTable.3.symbol"),
            description: t("savingContent.sgcSymbolsTable.3.description"),
          },
        ],

        monthlyInvestmentNote: t("savingContent.monthlyInvestmentNote"),

        howToUseTitle: t("savingContent.howToUseTitle"),
        howToUseSteps: [
          t("savingContent.howToUseSteps.0"),
          t("savingContent.howToUseSteps.1"),
          t("savingContent.howToUseSteps.2"),
          t("savingContent.howToUseSteps.3"),
          t("savingContent.howToUseSteps.4"),
          t("savingContent.howToUseSteps.5"),
          t("savingContent.howToUseSteps.6"),
        ],

        benefitsTitle: t("savingContent.benefitsTitle"),
        benefits: [
          t("savingContent.benefits.0"),
          t("savingContent.benefits.1"),
          t("savingContent.benefits.2"),
          t("savingContent.benefits.3"),
          t("savingContent.benefits.4"),
        ],

        tipTitle: t("savingContent.tipTitle"),
        tipDescription: t("savingContent.tipDescription"),
      },
      sipContent: {
        title: t("sipContent.title"),

        description: t("sipContent.description"),

        howItWorks: {
          title: t("sipContent.howItWorks.title"),
          paragraph: t("sipContent.howItWorks.paragraph"),
          formula: t("sipContent.howItWorks.formula"),
        },

        symbolColumn: t("sipContent.symbolColumn"),
        descriptionColumn: t("sipContent.descriptionColumn"),

        tableContent: [
          {
            symbol: t("sipContent.tableContent.0.symbol"),
            description: t("sipContent.tableContent.0.description"),
          },
          {
            symbol: t("sipContent.tableContent.1.symbol"),
            description: t("sipContent.tableContent.1.description"),
          },
          {
            symbol: t("sipContent.tableContent.2.symbol"),
            description: t("sipContent.tableContent.2.description"),
          },
          {
            symbol: t("sipContent.tableContent.3.symbol"),
            description: t("sipContent.tableContent.3.description"),
          },
          {
            symbol: t("sipContent.tableContent.4.symbol"),
            description: t("sipContent.tableContent.4.description"),
          },
        ],

        stepsToUse: {
          title: t("sipContent.stepsToUse.title"),
          steps: [
            {
              tag: t("sipContent.stepsToUse.steps.0.tag"),
              description: t("sipContent.stepsToUse.steps.0.description"),
            },
            {
              tag: t("sipContent.stepsToUse.steps.1.tag"),
              description: t("sipContent.stepsToUse.steps.1.description"),
            },
            {
              tag: t("sipContent.stepsToUse.steps.2.tag"),
              description: t("sipContent.stepsToUse.steps.2.description"),
            },
            {
              tag: t("sipContent.stepsToUse.steps.3.tag"),
              description: t("sipContent.stepsToUse.steps.3.description"),
            },
            {
              tag: t("sipContent.stepsToUse.steps.4.tag"),
              description: t("sipContent.stepsToUse.steps.4.description"),
            },
            {
              tag: t("sipContent.stepsToUse.steps.5.tag"),
              description: t("sipContent.stepsToUse.steps.5.description"),
            },
          ],
        },

        benefits: {
          title: t("sipContent.benefits.title"),
          points: [
            {
              tag: t("sipContent.benefits.points.0.tag"),
              description: t("sipContent.benefits.points.0.description"),
            },
            {
              tag: t("sipContent.benefits.points.1.tag"),
              description: t("sipContent.benefits.points.1.description"),
            },
            {
              tag: t("sipContent.benefits.points.2.tag"),
              description: t("sipContent.benefits.points.2.description"),
            },
            {
              tag: t("sipContent.benefits.points.3.tag"),
              description: t("sipContent.benefits.points.3.description"),
            },
            {
              tag: t("sipContent.benefits.points.4.tag"),
              description: t("sipContent.benefits.points.4.description"),
            },
          ],
        },

        keyConsiderations: {
          title: t("sipContent.keyConsiderations.title"),
          points: [
            {
              tag: t("sipContent.keyConsiderations.points.0.tag"),
              description: t(
                "sipContent.keyConsiderations.points.0.description",
              ),
            },
            {
              tag: t("sipContent.keyConsiderations.points.1.tag"),
              description: t(
                "sipContent.keyConsiderations.points.1.description",
              ),
            },
            {
              tag: t("sipContent.keyConsiderations.points.2.tag"),
              description: t(
                "sipContent.keyConsiderations.points.2.description",
              ),
            },
            {
              tag: t("sipContent.keyConsiderations.points.3.tag"),
              description: t(
                "sipContent.keyConsiderations.points.3.description",
              ),
            },
            {
              tag: t("sipContent.keyConsiderations.points.4.tag"),
              description: t(
                "sipContent.keyConsiderations.points.4.description",
              ),
            },
          ],
        },
      },
      lumpSumSWPContent: {
        title: t("lumpSumSWPContent.title"),

        description: t("lumpSumSWPContent.description"),

        howItWorks: {
          title: t("lumpSumSWPContent.howItWorks.title"),
          paragraph: t("lumpSumSWPContent.howItWorks.paragraph"),
          formula: t("lumpSumSWPContent.howItWorks.formula"),
        },

        symbolColumn: t("lumpSumSWPContent.symbolColumn"),
        descriptionColumn: t("lumpSumSWPContent.descriptionColumn"),

        tableContent: [
          {
            symbol: t("lumpSumSWPContent.tableContent.0.symbol"),
            description: t("lumpSumSWPContent.tableContent.0.description"),
          },
          {
            symbol: t("lumpSumSWPContent.tableContent.1.symbol"),
            description: t("lumpSumSWPContent.tableContent.1.description"),
          },
          {
            symbol: t("lumpSumSWPContent.tableContent.2.symbol"),
            description: t("lumpSumSWPContent.tableContent.2.description"),
          },
          {
            symbol: t("lumpSumSWPContent.tableContent.3.symbol"),
            description: t("lumpSumSWPContent.tableContent.3.description"),
          },
          {
            symbol: t("lumpSumSWPContent.tableContent.4.symbol"),
            description: t("lumpSumSWPContent.tableContent.4.description"),
          },
          {
            symbol: t("lumpSumSWPContent.tableContent.5.symbol"),
            description: t("lumpSumSWPContent.tableContent.5.description"),
          },
        ],

        stepsToUse: {
          title: t("lumpSumSWPContent.stepsToUse.title"),
          steps: [
            {
              tag: t("lumpSumSWPContent.stepsToUse.steps.0.tag"),
              description: t(
                "lumpSumSWPContent.stepsToUse.steps.0.description",
              ),
            },
            {
              tag: t("lumpSumSWPContent.stepsToUse.steps.1.tag"),
              description: t(
                "lumpSumSWPContent.stepsToUse.steps.1.description",
              ),
            },
            {
              tag: t("lumpSumSWPContent.stepsToUse.steps.2.tag"),
              description: t(
                "lumpSumSWPContent.stepsToUse.steps.2.description",
              ),
            },
            {
              tag: t("lumpSumSWPContent.stepsToUse.steps.3.tag"),
              description: t(
                "lumpSumSWPContent.stepsToUse.steps.3.description",
              ),
            },
            {
              tag: t("lumpSumSWPContent.stepsToUse.steps.4.tag"),
              description: t(
                "lumpSumSWPContent.stepsToUse.steps.4.description",
              ),
            },
            {
              tag: t("lumpSumSWPContent.stepsToUse.steps.5.tag"),
              description: t(
                "lumpSumSWPContent.stepsToUse.steps.5.description",
              ),
            },
          ],
        },

        benefits: {
          title: t("lumpSumSWPContent.benefits.title"),
          points: [
            {
              tag: t("lumpSumSWPContent.benefits.points.0.tag"),
              description: t("lumpSumSWPContent.benefits.points.0.description"),
            },
            {
              tag: t("lumpSumSWPContent.benefits.points.1.tag"),
              description: t("lumpSumSWPContent.benefits.points.1.description"),
            },
            {
              tag: t("lumpSumSWPContent.benefits.points.2.tag"),
              description: t("lumpSumSWPContent.benefits.points.2.description"),
            },
            {
              tag: t("lumpSumSWPContent.benefits.points.3.tag"),
              description: t("lumpSumSWPContent.benefits.points.3.description"),
            },
            {
              tag: t("lumpSumSWPContent.benefits.points.4.tag"),
              description: t("lumpSumSWPContent.benefits.points.4.description"),
            },
          ],
        },

        keyConsiderations: {
          title: t("lumpSumSWPContent.keyConsiderations.title"),
          points: [
            {
              tag: t("lumpSumSWPContent.keyConsiderations.points.0.tag"),
              description: t(
                "lumpSumSWPContent.keyConsiderations.points.0.description",
              ),
            },
            {
              tag: t("lumpSumSWPContent.keyConsiderations.points.1.tag"),
              description: t(
                "lumpSumSWPContent.keyConsiderations.points.1.description",
              ),
            },
            {
              tag: t("lumpSumSWPContent.keyConsiderations.points.2.tag"),
              description: t(
                "lumpSumSWPContent.keyConsiderations.points.2.description",
              ),
            },
            {
              tag: t("lumpSumSWPContent.keyConsiderations.points.3.tag"),
              description: t(
                "lumpSumSWPContent.keyConsiderations.points.3.description",
              ),
            },
            {
              tag: t("lumpSumSWPContent.keyConsiderations.points.4.tag"),
              description: t(
                "lumpSumSWPContent.keyConsiderations.points.4.description",
              ),
            },
          ],
        },
      },
      reportTitle: {
        bussinessLoan: t("reportTitle.bussinessLoan"),
        personalLoan: t("reportTitle.personalLoan"),
        contribution: t("reportTitle.contribution"),
        creditReport: t("reportTitle.creditReport"),
        earlyLoan: t("reportTitle.earlyLoan"),
        educationLoan: t("reportTitle.educationLoan"),
        fdReport: t("reportTitle.fdReport"),
        ltvReport: t("reportTitle.ltvReport"),
        lumpsumReport: t("reportTitle.lumpsumReport"),
        rdReport: t("reportTitle.rdReport"),
        savingReport: t("reportTitle.savingReport"),
        sipReport: t("reportTitle.sipReport"),
      },
      fileReport: {
        bussinessFile: t("fileReport.bussinessFile"),
        personalFile: t("fileReport.personalFile"),
        contributionFile: t("fileReport.contributionFile"),
        creditFile: t("fileReport.creditFile"),
        earlyFile: t("fileReport.earlyFile"),
        educationFile: t("fileReport.educationFile"),
        fdFile: t("fileReport.fdFile"),
        ltvFile: t("fileReport.ltvFile"),
        lumpsumFile: t("fileReport.lumpsumFile"),
        rdFile: t("fileReport.rdFile"),
        savingFile: t("fileReport.savingFile"),
        sipFile: t("fileReport.sipFile"),
      },
      ourTitle: t("ourTitle"),
      faqs: [
        {
          question: t("faqs.0.question"),
          answer: t("faqs.0.answer"),
        },
        {
          question: t("faqs.1.question"),
          answer: t("faqs.1.answer"),
        },
        {
          question: t("faqs.2.question"),
          answer: t("faqs.2.answer"),
        },
        {
          question: t("faqs.3.question"),
          answer: t("faqs.3.answer"),
        },
        {
          question: t("faqs.4.question"),
          answer: t("faqs.4.answer"),
        },
        {
          question: t("faqs.5.question"),
          answer: t("faqs.5.answer"),
        },
        {
          question: t("faqs.6.question"),
          answer: t("faqs.6.answer"),
        },
        {
          question: t("faqs.7.question"),
          answer: t("faqs.7.answer"),
        },
        {
          question: t("faqs.8.question"),
          answer: t("faqs.8.answer"),
        },
      ],
      faqsheader: {
        home: t("faqsheader.home"),
        faqs: t("faqsheader.faqs"),
        title: t("faqsheader.title"),
        subtitle: t("faqsheader.subtitle"),
        description: t("faqsheader.description"),
      },
      blogsheader: {
        home: t("blogsheader.home"),
        blogs: t("blogsheader.blogs"),
        title: t("blogsheader.title"),
        subtitle: t("blogsheader.subtitle"),
        description: t("blogsheader.description"),
      },
      tableheader: {
        contenthead: t("tableheader.contenthead"),
      },
      relatedblogs: {
        related: t("relatedblogs.related"),
      },
      moreoption: {
        readmore: t("moreoption.readmore"),
      },
      goalPlanner: {
        new: t("goalPlanner.new"),
        meetYour: t("goalPlanner.meetyour"),
        goalFinance: t("goalPlanner.goalFinance"),
        goalDesc: t("goalPlanner.goalDesc"),
        goalBtn: t("goalPlanner.goalBtn"),
        strategyTitleDefault: t("goalPlanner.strategyTitleDefault"),
        title: t("goalPlanner.title"),
        vehicle: t("goalPlanner.vehicle"),
        home: t("goalPlanner.home"),
        wedding: t("goalPlanner.wedding"),
        vacation: t("goalPlanner.vacation"),
        wealth: t("goalPlanner.wealth"),
        other: t("goalPlanner.other"),
        targetAmount: t("goalPlanner.targetAmount"),
        timePeriod: t("goalPlanner.timePeriod"),
        expectedReturn: t("goalPlanner.expectedReturn"),
        years: t("goalPlanner.years"),
        months: t("goalPlanner.months"),
        currentSavings: t("goalPlanner.currentSavings"),
        planBtn: t("goalPlanner.planBtn"),
        wantSave: t("goalPlanner.wantSave"),
        for: t("goalPlanner.for"),
        in: t("goalPlanner.in"),
        enterAmount: t("goalPlanner.enterAmount"),
        enterTimePeriod: t("goalPlanner.enterTimePeriod"),
        enterGoalName: t("goalPlanner.enterGoalName"),
        thinking: t("goalPlanner.thinking"),
        hard: t("goalPlanner.hard"),
        easy: t("goalPlanner.easy"),
        medium: t("goalPlanner.medium"),
        impossible: t("goalPlanner.impossible"),
        recommendation: t("goalPlanner.recommendation"),
        mothlySavingNeed: t("goalPlanner.mothlySavingNeed"),
        disclaimer: t("goalPlanner.disclaimer"),
        readyToPlan: t("goalPlanner.readyToPlan"),
        proTip: t("goalPlanner.proTip"),
        errorCalculating: t("goalPlanner.errorCalculating"),
        tryAgain: t("goalPlanner.tryAgain"),
        goalNameMaxLength: t("goalPlanner.goalNameMaxLength"),
        amountMin: t("goalPlanner.amountMin"),
        targetAmountRequired: t("goalPlanner.targetAmountRequired"),
        targetAmountMax: t("goalPlanner.targetAmountMax"),
        timePeriodMin: t("goalPlanner.timePeriodMin"),
        timePeriodRequired: t("goalPlanner.timePeriodRequired"),
        expectedReturnMin: t("goalPlanner.expectedReturnMin"),
        expectedReturnMax: t("goalPlanner.expectedReturnMax"),
        expectedReturnRequired: t("goalPlanner.expectedReturnRequired"),
        yearsMaxError: (maxYears) => t("goalPlanner.yearsMaxError", { maxYears }),
        monthsMaxError: (maxMonths) => t("goalPlanner.monthsMaxError", { maxMonths }),
        currentSavingsMin: t("goalPlanner.currentSavingsMin"),
        currentSavingsMax: t("goalPlanner.currentSavingsMax"),
        targetAmountHigherThanSavings: t(
          "goalPlanner.targetAmountHigherThanSavings",
        ),
        difficultyTooltip: t("goalPlanner.difficultyTooltip"),
      },
      Positive: t("Positive"),
      Negative: t("Negative"),
      Neutral: t("Neutral"),
      aiAnalysis: {
        aiAnalysis: t("aiAnalysis.aiAnalysis"),
        analyzeWithAI: t("aiAnalysis.analyzeWithAI"),
        ratingTooltip: t("aiAnalysis.ratingTooltip"),
      },
      appPromo: {
        getOurApp: t("appPromo.getOurApp"),
        tagline: t("appPromo.tagline"),
      },
      settings: {
        title: t("settings.title"),
        country: t("settings.country"),
        currency: t("settings.currency"),
        language: t("settings.language"),
      },
    };
  }, [t, currentYear, currencyValue]);

  const timeUnits = useMemo(() => {
    return {
      Year: t("year"),
      Month: t("month"),
      Day: t("day"),
      Years: t("years"),
      Months: t("months"),
    };
  }, [t]);

  return { t, textData, timeUnits };
};

export default useLocale;
